import { ref, computed, watch, reactive } from 'vue'
import { useRouter } from "vue-router";
import axios from 'axios'
import { connect as natsConnect, JSONCodec } from 'nats.ws';

var timer = null
const loginStatus = ref(false)
const userInfo = ref({})
const token = ref('')
const oldPath = '/bit'
const user = ref({})
const version = ref({})
const centrifuge = ref('')

const Accounts = ref('')
const privat = ''
const AccountsFullData = reactive({})
const PositionsFullData = reactive({})
const OrdersFullData = reactive({})
const TradesFullData = reactive({})
const Instruments = reactive({})
const MoneyTransaction = reactive({})
const ServiceHistory = reactive({})
const FullHistory = reactive({})
const CentrifugoPrefix = ref('')
const langSelect = ref(0)
const sendedLoginInfo = ref(false);
const dataResponse = ref(false)
const accountsAddress = reactive({})
const mynats = ref(undefined)
const connectingMynats = ref(false)
const techTimeout = ref(true)
const wssclosed = ref(true)
const cryptoServerIsActived = ref(false)
const showLeftMenu = ref(false)
const aumShares = ref({})
//onst timeTick = ref(false)
const natsservers = [
  { servers: "wss://ae.exchange/njs" }
];
const langTextes = [
  "Русский",
  "English"
]
const langImages = [
  "ae_flag_ru.png",
  "ae_flag_uk.png"
]
const serverConf = [
  {
    name: "GAME",
    color: "#26c39e",
    path: "/lk",
    desktopterminalfilename: "OptionLabGameAE.msi",
    androidfilename: "app-release-v-0.23.14.apk"
  },
  {
    name: "TRADE",
    color: "#e82862",
    path: "/lktrade",
    desktopterminalfilename: "OptionLabTradeAE.msi",
    androidfilename: "app-release-v-0.23.14.apk"
  },
  {
    name: "TEST",
    color: "#2858e8",
    path: "/lktest",
    desktopterminalfilename: "OptionLabGameAE.msi"
  }
]
const currentServer = 1

const ServerUrl = 'https://ae.exchange' + serverConf[currentServer].path
const WebUrl = 'https://ae.exchange' + serverConf[currentServer].path
//const WebUrl = 'http://127.0.0.1:8080' + serverConf[currentServer].path
const calcTicker = ref("BTC")

const orderStatusName = [
  "",
  "",
  "",
  "pending",
  "canceling",
  "canceled",
  "partFilled",
  "filled",
  "rejected",
  "cancelFailed"
]
let messagesArray = []
let workFromMessagesArray = false
const WorkMessagesArray = () => {
  if (workFromMessagesArray === false) {
    while (messagesArray.length > 0) {
      workFromMessagesArray = true
      parseOrdersData()
    }
    workFromMessagesArray = false
  }
}
/*
const StartGlobalTimer = () => {
  console.log("Start global timer")
  setInterval(() => {
    console.log("globalTimer");
    timeTick.value = !timeTick.value;
    console.log( timeTick.value)
  }, 6000)
}
*/
const parseOrdersData = () => {
  const data = messagesArray[0]
  for (let key in data) {
    ParseAccountOrdersData(key, data[key])
  }
  messagesArray.shift()
}
const ParseAccountOrdersData = (acc, message) => {
  // console.log(message)
  // OrdersFullData[acc]=[]
  for (let i = 0; i < message.length; i++) {
    let index = OrdersFullData[acc].findIndex(x => x.OrderID === message[i][2])
    if (index < 0) {
      const item = {
        Ticker: message[i][0],
        Status: orderStatusName[message[i][1]],
        OrderID: message[i][2],
        Shares: message[i][3],
        Price: message[i][4],
        SharesRest: message[i][5],
        LastShares: message[i][6],
        LastPrice: message[i][7],
        LastChangeStatusTime: message[i][8],
        Moment: message[i][9],
        Comment: message[i][10],
        RestExtID: message[i][11]
      }
      //  OrdersFullData[acc].push(item)
      OrdersFullData[acc].unshift(item)
    } else {
      OrdersFullData[acc][index].Status = orderStatusName[message[i][1]]
    }

  }
}
Instruments[calcTicker.value] = { "Last": 0, "Sub": null }


export const useMyStorage = () => {

  const router = useRouter()


  const logout = () => {
    if (mynats.value !== undefined) {
      connectingMynats.value = false
      mynats.value.close()
    }
    if (loginStatus.value) {
      const url = WebUrl + "/users/logout"
      axios.defaults.headers.common["Authorization"] = "Bearer " + token.value;
      axios.post(
        url, { logout: true, }
      );
      loginStatus.value = false
      userInfo.value = {}
      window.location.href = WebUrl + '#/login'
      location.reload()
    }
    //router.push('/login')
  }
  const loginStatusSet = (status) => {
    loginStatus.value = status
  }
  const loadVersion = () => {
    axios.get(ServerUrl + '/version.json').then(function (response) {
      //   console.log(response);
      version.value = response.data;
    })
  }
  const natsInit = async () => {
    connectingMynats.value = true
    natsservers.forEach(async (v) => {
      try {
        mynats.value = await natsConnect(v);
        console.log(`connected to ${mynats.value.getServer()}`);
        // this promise indicates the client closed
        wssclosed.value = mynats.value.closed();
        //  console.log(wssclosed.value)
        // do something with the connection
        /*
         // close the connection
         await nc.close();
         // check if the close was OK
         const err = await done;
         if (err) {
           console.log(`error closing:`, err);
         } */

        MyNatsSubscribe(serverConf[currentServer].name + "-system", TechTimeout)
        MyNatsGetServerStatus()
        TestServerMsg()
      } catch (err) {
        console.log(`error connecting to ${JSON.stringify(v)}`);
      }
    })

  }
  function TechTimeout(msg) {
    switch (msg.Msg) {
      case "techtimeout":
        logout();
        techTimeout.value = true;

        break;
      case "closetechtimeout":
        techTimeout.value = false;
        break;
    }
  }
  function delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  const SetAccountTronAddress = (msg) => {
    console.log(msg)
    if (msg.Addr != undefined) {
      accountsAddress[msg.Acc].qrUSDT =
        "data:image/jpeg;base64," + msg.Png;
      accountsAddress[msg.Acc].addressUSDT =
        msg.Addr;
      accountsAddress[msg.Acc].accUsdtAddresIs = true;
    }
  }
  /* const SetAccountTonAddress = (msg) => {
        console.log(msg)
     if (msg.Addr != undefined) {
       accountsAddress[msg.Acc].qrTonUSDT =
         "data:image/jpeg;base64," + msg.Png;
       accountsAddress[msg.Acc].addressTonUSDT =
         msg.Addr;
       accountsAddress[msg.Acc].accTonUsdtAddresIs = true;
     }
   }*/
  const SetAccountBitAddress = (msg) => {
    //   console.log(msg)
    if (msg.Addr != undefined) {
      accountsAddress[msg.Acc].qrBTC =
        "data:image/jpeg;base64," + msg.Png;
      accountsAddress[msg.Acc].addressBTC =
        msg.Addr;
      // accountsAddress[msg.Acc].accBitAddresIs = true;
    }
  }
  const GetAccountAddresses = async (data) => {
    data.Server = serverConf[currentServer].name
    await CheckCrypto()
    if (cryptoServerIsActived.value === true) {
      const jc = JSONCodec();
      /*     const newChTon = "ton-response-" + Math.random();
           MyNatsSubscribe(newChTon, SetAccountTonAddress)
           await mynats.value
             .request("ton-"+serverConf[currentServer].name, jc.encode(data), { timeout: 1 * 1000, noMux: true, reply: newChTon })
             //.request("tron-info", jc.encode(data), {timeout:60000})
             .then(() => {
               //   console.log(m)
               //     const msg = jc.decode(m.data)
               //   console.log(msg)
               
             })
             .catch((err) => {
               console.log(`problem with request: ${err.message}`);
             })*/
      const newCh = "tron-response-" + Math.random();
      MyNatsSubscribe(newCh, SetAccountTronAddress)
      await mynats.value
        //   .request("tron-"+serverConf[currentServer].name, jc.encode(data), { timeout: 1 * 1000, noMux: true, reply: newCh })
        .request("tron", jc.encode(data), { timeout: 1 * 1000, noMux: true, reply: newCh })
        .then(() => {
          //   console.log(m)
          //     const msg = jc.decode(m.data)
          //   console.log(msg)
          /**/
        })
        .catch((err) => {
          console.log(`problem with request: ${err.message}`);
        })
      const newChBit = "bit-response-" + Math.random();
      MyNatsSubscribe(newChBit, SetAccountBitAddress)
      await mynats.value
        .request("bit", jc.encode(data), { timeout: 1 * 1000, noMux: true, reply: newChBit })
        //.request("tron-info", jc.encode(data), {timeout:60000})
        .then(() => {
          //      console.log(m)
          //  const msg = jc.decode(m.data)
          //       console.log(msg)
          /**/
        })
        .catch((err) => {
          console.log(`problem with request: ${err.message}`);
        })
    }
  };
  const CheckCrypto = async () => {
    const jc = JSONCodec();
    await mynats.value
      .request("crypto", jc.encode({ test: "test" }), { timeout: 1 * 1000 })
      //.request("tron-info", jc.encode(data), {timeout:60000})
      .then(() => {
        cryptoServerIsActived.value = true
        /**/
      })
      .catch((err) => {
        console.log(`problem with request: ${err.message}`);
        cryptoServerIsActived.value = false
      })
  }
  const GetNewBitAcoountAddresses = async (data) => {
    await CheckCrypto()
    if (cryptoServerIsActived.value === true) {
      const jc = JSONCodec();
      const newChBit = "bit-response-" + Math.random();
      MyNatsSubscribe(newChBit, SetAccountBitAddress)
      await mynats.value
        .request("bit", jc.encode(data), { timeout: 1 * 1000, noMux: true, reply: newChBit })
        //.request("tron-info", jc.encode(data), {timeout:60000})
        .then((m) => {
          console.log(m)
          const msg = jc.decode(m.data)
          console.log(msg)
          /**/
        })
        .catch((err) => {
          console.log(`problem with request: ${err.message}`);
        })
    }
  };
  const GetTronAccountBalances = async (account) => {
    const jc = JSONCodec();
    await CheckCrypto();
    if (cryptoServerIsActived.value === true) {
      const newCh = "tron-response-" + Math.random();
      MyNatsSubscribe(newCh, (msg) => { console.log(msg) })
      await mynats.value
        .request("tron", jc.encode({ func: "GetBalances", data: "{\"inaccount\":\"" + account + "\"}" }), { timeout: 1 * 1000, noMux: true, reply: newCh })
    }

  }
  const TronSendAllToSigner = async (account) => {
    const jc = JSONCodec();
    await CheckCrypto();
    if (cryptoServerIsActived.value === true) {
      const newCh = "tron-response-" + Math.random();
      MyNatsSubscribe(newCh, (msg) => { console.log(msg) })
      await mynats.value
        .request("tron", jc.encode({ func: "SendAllTRC20ToSigner", data: "{\"inaccount\":\"" + account + "\"}" }), { timeout: 1 * 1000, noMux: true, reply: newCh })
    }

  }
  const MyNatsSubscribe = async (channel, callbackfunction) => {
    while (mynats.value == undefined) {
      await delay(100)
    }

    const ch = mynats.value.subscribe(channel);
    const jc = JSONCodec();

    for await (const m of ch) {
      //  console.log(m.data)
      callbackfunction(jc.decode(m.data))
    }
  }
  const MyNatsGetServerStatus = async () => {
    while (mynats.value == undefined) {
      await delay(100)
    }
    const jc = JSONCodec();
    mynats.value.publish(serverConf[currentServer].name + "-system", jc.encode({ Msg: "getserverstatus" }));

  }
  const TestServerMsg = async () => {
    while (mynats.value == undefined) {
      await delay(100)
    }
    const jc = JSONCodec();

    mynats.value.publish("telegram", jc.encode({ To: "33149825", Msg: "TestServerMsg" }));

  }
  if (connectingMynats.value == false) {
    natsInit()
  }

  // watch(mynats, (newV) => {
  // console.log(newV)
  // console.log(mynats.value.isClosed())
  // })
  watch(token, (newV, oldV) => {
    if (newV != '' && newV != oldV && sendedLoginInfo.value === false) {

      MyNatsSubscribe(serverConf[currentServer].name + "-" + userInfo.value.Info.SessionID, PrivatResponse)
      GetFullUserInfo()
    }

  })
  const GetFullUserInfo = () => {
    sendedLoginInfo.value = true;
    const url = ServerUrl + "/users/user"
    axios.defaults.headers.common["Authorization"] = "Bearer " + token.value;
    axios.get(url).then(function (response) {
      user.value = response.data.data
      Accounts.value = user.value.Accounts

      //  CentrifugeConnect()

      for (let i = 0; i < Accounts.value.length; i++) {
        MoneyTransaction[Accounts.value[i].Account] = Accounts.value[i].MTrans;
        let obj = {
          Account: Accounts.value[i].Account,
          Fee: Accounts.value[i].Fee,
          GM: Accounts.value[i].GM,
          Money: Accounts.value[i].Money,
          MoneyFree: Accounts.value[i].MoneyFree
        }
        //  console.log(Accounts.value[i].Account)
        AccountsFullData[Accounts.value[i].Account] = obj
        PositionsFullData[Accounts.value[i].Account] = Accounts.value[i].Positions
        let pos = PositionsFullData[Accounts.value[i].Account]
        for (let i2 = 0; i2 < pos.length; i2++) {
          subscribeInstrument(pos[i2].Ticker)
        }
        OrdersFullData[Accounts.value[i].Account] = Accounts.value[i].Orders.sort((a, b) => {
          if (a.OrderID > b.OrderID) {
            return -1;
          }
          if (a.OrderID < b.OrderID) {
            return -1;
          }
          return 0
        })
        pos = OrdersFullData[Accounts.value[i].Account]
        for (let i2 = 0; i2 < pos.length; i2++) {
          subscribeInstrument(pos[i2].Ticker)
        }
        subscribeInstrument(calcTicker.value)
        TradesFullData[Accounts.value[i].Account] = Accounts.value[i].Trades
        LoadServiceHistory(Accounts.value[i].Account)
      }
      loginStatus.value = true;
      sendedLoginInfo.value = false;
      LoadAumShares()
      startTimer();
    })
  }
  const LoadAumShares = () => {
    const url = ServerUrl + "/aum/shares"
    axios.get(url).then(function (response) {
      aumShares.value = response.data
      //  console.log(response)
    })
  }

  //watch(AccountsFullData,()=>{console.log("accounts changed")})
  const LoadAllHistory = () => {
    for (let i = 0; i < Accounts.value.length; i++) {
      LoadServiceHistory(Accounts.value[i].Account)
    }
  }
  const OrdersResponse = (message) => {
    /*
    {
      "Type":"OrdersResponse", <- тип нового сообщения
      "SessionID":"615bfef9e06710f86905e772",
      "o": <- объект, содержит изменение статусов ордеров по счетам пользователя за период таймера
      {
        "ACC01":[  <-массив ордеров по счету
            ["TestFutures", <- тикер
              3, <- статус { sePending=3, seCanceling=4,seCanceled=5,sePartFilled=6,seFilled=7,seRejected=8,seCancelFailed=9 }
              2730109932, <- ID
              1.0, <- количество всего
              1000.0, <- цена
              1.0, <- осталось исполнить количество
              0.0, <- последняя сделка по ордеру, количество
              0.0, <- последняя сделка по ордеру, цена
              1633419035, <- время изменения статуса
              1633419035, <- время создание ордера
             "from MarketDepth",  <- комментарий
              0 <- rest ExtID
            ]
          ]
      },
      "a": <- агрегированные по тикеру ордера пользователя
          {
        "TestFutures":[{
            "price":1000.0,
            "shares":1.0
            }]
          }
    }
     */

    let data = message.data.O
    messagesArray.push(data)
    WorkMessagesArray()
    /*
    for (let key  in data){
        ParseAccountOrdersData(key, data[key])

        console.log(key)
    }*/
    /*  let obj = {}
   //   console.log("len-" + OrdersFullData[acc].length)
    //  console.log(data)
      if (OrdersFullData[acc].length > 0) {
          obj = OrdersFullData[acc]
          let ind = obj.findIndex(x => x.OrderID === data.OrderID)
        //  console.log(ind)
        //  console.log(obj)
          if (ind < 0) {
              if (data.Status !== "canceled" || data.Status !== "filled" || data.Status !== "rejected") {
                  OrdersFullData[acc].push(data)
                  subscribeInstrument(data.Ticker)
              }
          } else {
              if (data.Status === "canceled" || data.Status === "filled"|| data.Status === "rejected") {
                  OrdersFullData[acc].splice(ind, 1)
                  return
              } else {
                  OrdersFullData[acc][ind].Status = data.Status
                  OrdersFullData[acc][ind].Shares = data.Shares
                  OrdersFullData[acc][ind].SharesRest = data.SharesRest
              }
          }

      } else {
          OrdersFullData[acc].push(data)
          subscribeInstrument(data.Ticker)
      }*/
  }

  const TradeResponse = (message) => {
    // console.log(message)
    let data = message.data
    let acc = message.data.Account
    let obj = {}
    if (TradesFullData[acc]) {
      obj = TradesFullData[acc]
    }
    for (let key in data) {
      obj[key] = data[key]
    }
    TradesFullData[acc] = obj
  }
  const AccountResponse = (message) => {
    //    console.log(message)
    let data = message.data
    let acc = message.data.Account
    let obj = {}
    if (AccountsFullData[acc]) {
      obj = AccountsFullData[acc]
    }
    for (let key in data) {
      obj[key] = data[key]
    }
    AccountsFullData[acc] = obj
    // console.log(AccountsFullData)

  }
  const VMResponse = (message) => {
    console.log(message)
  }
  const PositionResponse = (message) => {
    /*OpenDate: 1606910142
OpenPrice: 18690.000002
Shares: 0
Ticker: "BTCZ20"
VM: 0*/
    let acc = message.data.Account
    let pos = message.data.Pos
    let obj = {}
    if (PositionsFullData[acc]) {
      obj = PositionsFullData[acc]
    } else {
      PositionsFullData[acc] = [pos]
      subscribeInstrument(pos.Ticker)
      return
    }
    let i = obj.findIndex(x => x.Ticker === pos.Ticker)
    if (i < 0) {
      PositionsFullData[acc].push(pos)
      subscribeInstrument(pos.Ticker)
      return
    }
    if (pos.Shares === 0) {
      PositionsFullData[acc].splice(i, 1)
      return
    }
    for (let key in pos) {
      PositionsFullData[acc][i][key] = pos[key]
    }
    // console.log("positions update")
  }
  const AggrOrdersResponse = (message) => {
    console.log(message)
  }
  const MessageResponse = (message) => {
    console.log(message)
  }
  const MoneyTransactionResponse = (message) => {
    // console.log(message)
    let newData = message.data;
    if (MoneyTransaction[newData.dbt] != undefined) {
      MoneyTransaction[newData.dbt].unshift(newData);
    } else {
      MoneyTransaction[newData.crd].unshift(newData);
    }
  }
  const PrivatResponse = (message) => {
    dataResponse.value = !dataResponse.value;

    // console.log(message)
    switch (message.Type) {
      case "OrdersResponse":
        OrdersResponse(message);
        break;
      case "TradeResponse":
        TradeResponse(message);
        break;
      case "AccountResponse":
        AccountResponse(message);
        break;
      case "VMResponse":
        VMResponse(message);
        break;
      case "PositionResponse":
        PositionResponse(message);
        break;
      case "AggrOrdersResponse":
        AggrOrdersResponse(message);
        break;
      case "MessageResponse":
        MessageResponse(message);
        break;
      case "MoneyTransactionResponse":
        MoneyTransactionResponse(message);
        break;
      case "LogoutResponse":
        LogoutResponse(message);
        break;
    }
  }
  const LogoutResponse = (msg) => {
    console.log(msg)
    logout();
  }
  const getAccountInfo = (acc) => {
    return computed(() => AccountsFullData[acc])
  }
  const subscribeInstrument = async (ticker) => {
    if (Instruments[ticker] == undefined || Instruments[ticker].Sub == null) {
      Instruments[ticker] = { "Last": 0, "Sub": {} };
      /* Instruments[ticker].Sub = centrifuge.value.subscribe(
         "instruments:" + CentrifugoPrefix.value + ticker,
         { publish: InstrumentTick })*/
      MyNatsSubscribe(serverConf[currentServer].name + ".instruments." + ticker, InstrumentTick)
      const url = ServerUrl + "/users/instruments"
      axios.defaults.headers.common["Authorization"] = "Bearer " + token.value;
      const insts = await axios.post(
        url, { tickers: [ticker], }
      );
      // console.log(insts)
      if (insts.data.data.Instruments[0].Instrument !== undefined) {
        Instruments[ticker] = insts.data.data.Instruments[0].Instrument;
        const message = insts.data.data.Instruments[0].quote
        for (let key in message) {
          if (!Instruments[ticker][key]) {
            Instruments[ticker][key] = message[key]
          }
        }
      }
    }

  }
  const InstrumentTick = (data) => {
    const message = data
    if (Instruments[message.Ticker]) {
      for (let key in message) {
        if (message[key] != null) {
          Instruments[message.Ticker][key] = message[key]
        }
        if (!Instruments[message.Ticker][key]) {
          Instruments[message.Ticker][key] = message[key]
        }
      }
    } else {
      Instruments[message.Ticker] = message
    }
    // console.log(message)
  }
  /* watch(()=>OrdersFullData, (nV) => {

      // console.log("global OrdersFullData watch")
      // console.log(nV)
   },{ deep: true })*/
  const GetAllAccountsToString = () => {
    let acc = '';
    userInfo.value.Info.Accounts.forEach((el) => {
      if (acc != '') {
        acc = acc + ','
      }
      acc = acc + el.Account
    })
    return acc;
  }
  const startTimer = () => {
    if (timer != null) {
      clearTimeout(timer)
    }
    timer = setInterval(() => {
      console.log("timer");
      logout();
    }, 6000000)
  }
  const RestartTimer = () => {
    clearTimeout(timer);
    startTimer();
  }
  const LoadServiceHistory = (acc) => {
    const url = ServerUrl + "/users/servicehistory?accounts=" + acc
    axios.defaults.headers.common["Authorization"] = "Bearer " + token.value;
    axios.get(url).then(function (response) {

      ServiceHistory.value = response.data.data
      ServiceHistory.value.forEach((element, i) => {
        let hs = element.HistoryInfo.replaceAll("'", "\"")
        /* hs = hs.replaceAll("подписка", "subscribe")
         hs = hs.replaceAll("отписка", "unsubscribe")
         console.log(hs)*/
        ServiceHistory.value[i].HistoryInfo = JSON.parse(hs)
        //   console.log(element.Uid)
        FullHistory[element.Uid] = ServiceHistory.value[i]

      })
      // console.log(FullHistory)
    })
  }
  const LoadGraphInfo = (ticker) => {
    const url = ServerUrl + "/users/instrument/history"
    axios.post(url, { Ticker: ticker, Size: "60" }).then(function (response) {
      console.log(response)
    })
  }
  const CheckPosition = (account, ticker) => {
    const possitions = PositionsFullData[account]
    console.log(possitions)
    if (possitions === undefined) {
      return undefined
    }
    let shares = 0
    possitions.forEach((v) => {
      if (v.Ticker === ticker) {
        shares = v.Shares
      }
    })
    return shares
  }
  return {
    loginStatus: computed(() => loginStatus.value),
    userInfo,
    user: computed(() => user.value),
    token,
    oldPath,
    logout,
    loginStatusSet,
    router,
    ServerUrl,
    accounts: computed(() => Accounts.value),
    centrifuge: computed(() => centrifuge.value),
    CheckPosition,
    getAccountInfo,
    getAccPositions,
    getAccOrders,
    getAccTrades,
    getInstruments,
    getAccountsFull: computed(() => AccountsFullData),
    getPositionsFull: computed(() => PositionsFullData),
    getTradesFull: computed(() => TradesFullData),
    getOrdersFull: computed(() => OrdersFullData),
    getInstrumentsFull: computed(() => Instruments),
    CentrifugoPrefix,
    langSelect,
    langTextes,
    langImages,
    OrdersFullData,
    AccountsFullData,
    calcTicker,
    privat,
    currentServer,
    serverConf,
    orderStatusName,
    loadVersion,
    learningLevels,
    indicators,
    strateges,
    strategesEng,
    funds,
    fundsEng,
    tests,
    GetAllAccountsToString,
    subscribeInstrument,
    MoneyTransaction,
    dr: computed(() => dataResponse.value),
    dataResponse,
    accountsAddress,
    timer,
    RestartTimer,
    MyNatsSubscribe,
    techTimeout,
    wssclosed,
    GetAccountAddresses,
    mynats,
    GetNewBitAcoountAddresses,
    CheckCrypto,
    cryptoServerIsActived,
    GetTronAccountBalances,
    TronSendAllToSigner,
    LoadServiceHistory,
    LoadAllHistory,
    ServiceHistory,
    FullHistory,
    LoadGraphInfo,
    WebUrl,
    showLeftMenu,
    GetFullUserInfo,
    Instruments,
    aumShares
  }
}

export function getAccInfo(acc) {
  return computed(() => AccountsFullData[acc])
}

export function getAccPositions(acc) {
  return computed(() => PositionsFullData[acc])
}

export function getAccOrders(acc) {
  return computed(() => OrdersFullData[acc])
}

export function getAccTrades(acc) {
  return computed(() => TradesFullData[acc])
}

export function getInstruments() {
  return computed(() => Instruments)
}
const tests = [
  {
    name: "Знание правил и торговых инструментов биржи АЕ",
    url: "https://onlinetestpad.com/3tj7g6wsaiqse",
    image:
      '<svg width="42" height="21" viewBox="0 0 42 21" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
      '<path d="M18.2859 20H13.2059V18C11.8193 19.6533 9.77927 20.48 7.08594 20.48C5.3526 20.48 3.7926 19.92 2.40594 18.8C1.04594 17.6533 0.365938 16.08 0.365938 14.08C0.365938 12 1.0326 10.44 2.36594 9.4C3.72594 8.36 5.29927 7.84 7.08594 7.84C9.8326 7.84 11.8726 8.62667 13.2059 10.2V7.6C13.2059 6.61333 12.8193 5.82667 12.0459 5.24C11.2726 4.65333 10.2459 4.36 8.96594 4.36C6.85927 4.36 4.97927 5.12 3.32594 6.64L1.40594 3.24C3.69927 1.21333 6.5126 0.199999 9.84594 0.199999C12.3259 0.199999 14.3526 0.773332 15.9259 1.92C17.4993 3.06667 18.2859 4.93333 18.2859 7.52V20ZM9.12594 17.04C11.0193 17.04 12.3793 16.48 13.2059 15.36V12.96C12.3793 11.84 11.0193 11.28 9.12594 11.28C8.08594 11.28 7.21927 11.5467 6.52594 12.08C5.8326 12.5867 5.48594 13.2933 5.48594 14.2C5.48594 15.08 5.8326 15.7733 6.52594 16.28C7.21927 16.7867 8.08594 17.04 9.12594 17.04ZM32.4047 20.48C29.418 20.48 26.9514 19.5467 25.0047 17.68C23.058 15.8133 22.0847 13.36 22.0847 10.32C22.0847 7.46667 23.018 5.06667 24.8847 3.12C26.778 1.17333 29.178 0.199999 32.0847 0.199999C34.9647 0.199999 37.298 1.18667 39.0847 3.16C40.8714 5.10667 41.7647 7.66667 41.7647 10.84V11.96H27.4047C27.5647 13.24 28.138 14.3067 29.1247 15.16C30.1114 16.0133 31.3914 16.44 32.9647 16.44C33.818 16.44 34.738 16.2667 35.7247 15.92C36.738 15.5733 37.538 15.1067 38.1247 14.52L40.3647 17.8C38.418 19.5867 35.7647 20.48 32.4047 20.48ZM36.8447 8.52C36.7647 7.42667 36.3247 6.44 35.5247 5.56C34.7514 4.68 33.6047 4.24 32.0847 4.24C30.6447 4.24 29.5247 4.68 28.7247 5.56C27.9247 6.41333 27.458 7.4 27.3247 8.52H36.8447Z" fill="#E82862"/>\n' +
      "</svg>\n",
    type: "test",
    count: 13,
  },
  {
    name: "Знания по базовым понятиям в торговле опционами ",
    url: "https://onlinetestpad.com/wh4sylso7hbtc",
    image:
      '<svg width="36" height="33" viewBox="0 0 36 33" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
      '<path d="M2 29.4762L2 15.7619" stroke="#E82862" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>\n' +
      '<path d="M8.0957 21.8571V8.14285" stroke="#E82862" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>\n' +
      '<path d="M17.2383 31V17.2857" stroke="#E82862" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>\n' +
      '<path d="M24.8574 15.7619V2.04762" stroke="#E82862" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>\n' +
      '<path d="M34 26.4286V12.7143" stroke="#E82862" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>\n' +
      "</svg>\n",
    type: "test",
    count: 10,
  },
];
const funds = [
  {
    blockHeader: 'Фонды',
    blockItems: [
    /*  {
        img: 'images/AlexTrade.svg',
        imgx: 'right',
        imgy: 'top',
        name: 'BLSW',
        header: 'Фонд BLACK SWAN',
        priceTicker: 'BLSW',
        priceStep: 1,
        startValue: 100,
        priceText: "USDT",
        volumeText: "USDT",
        startDate: "10.02.2026",
        content:
          'Стратегия фонда - охота на черного лебедя - редкое неожиданное событие вследствие которого происходит сильное ценовое движение.',
        info: {
          img: "images/SPUTIBTC.png",
          header: "",
          content: "",
          params: [[
            "Управляющий: Delta трейдер.",
            "Стратегии фонда: ловушки волатильности",
            "Торговые инструменты: опционы и фьючерсы",
            "Вознаграждение управляющего: 20% от прибыли (High-Water Mark), комиссия за управление 0%.",
            "Доп. инфо: стратегии фонда получают прибыль на неожиданных ценовых движениях (черный лебедь)."
          ], [
            "Минимальный объем подписки: 100 USDT",
            "Комиссии: Комиссии: при подписке/отписке комиссия не взимается.",
            "Определение цены: еженедельно в 9:10 UTC. LAST = Money / Shares. Где Money текущий лимит средств аккаунта фонда, Shares - объем подписок на фонд.",
            "Заявки на подписку/отписку поданные до 9:10 UTC исполняются до 10:10 UTC по цене LAST определенной в 9:10 UTC. Операции подписки/отписки производятся в понедельник-пятница."

          ]],
          warning: "Внимание! Фонд может иметь существенные риски, вплоть до полной потери средств. Все возможные риски принимает на себя подписчик фонда.",
        },
      }, */
      {
        img: 'images/AlexTrade.svg',
        imgx: 'right',
        imgy: 'top',
        name: 'AlexTrade',
        header: 'Фонд AlexTrade',
        priceTicker: 'AlexTrade',
        priceStep: 1,
        startValue: 100,
        priceText: "USDT",
        volumeText: "USDT",
        startDate: "03.03.2023",
        content:
          'Стратегии фонда: среднесрочные трендовые стратегии, а также покупка/продажа волатильности опционов. Торговые инструменты: фьючерс и опционы на Bitcoin',
        info: {
          img: "images/SPUTIBTC.png",
          header: "Проданный пут  BTC",
          content: "",
          params: [[
            "Управляющий: Алексей Лозицкий, опытный трейдер.",
            "Стратегии фонда: среднесрочные трендовые стратегии, а также покупка/продажа волатильности опционов.",
            "Торговые инструменты: фьючерс и опционы на Bitcoin",
            "Параметры: вознаграждение управляющего 20% от прибыли (High-Water Mark), комиссия за управление 0%, целевая доходность 30-50% годовых.",
            "Доп. инфо: <a href='https://youtu.be/YqAAGS_cGO8' target='_blank'>видео</a> ",
            "Контакт управляющего: @AlexTrade2020"
          ], [
            "Минимальный объем подписки: 100 USDT",
            "Комиссии: Комиссии: при подписке/отписке комиссия не взимается.",
            "Определение цены: ежедневно в 9:10 UTC. LAST = Money / Shares. Где Money текущий лимит средств аккаунта фонда, Shares - объем подписок на фонд.",
            "Заявки на подписку/отписку поданные до 9:10 UTC исполняются до 10:10 UTC по цене LAST определенной в 9:10 UTC. Операции подписки/отписки производятся в понедельник-пятница."

          ]],
          warning: "Внимание! Фонд может иметь существенные риски, вплоть до полной потери средств. Все возможные риски принимает на себя подписчик фонда. Биржа АЕ не несет никакой ответственности за деятельность управляющего фонда.",
        },
      },
      {
        img: 'images/AlexTrade.svg',
        imgx: 'right',
        imgy: 'top',
        name: 'WheelBTCAU',
        header: 'Фонд BTC Wheel ATM (USDT)',
        priceTicker: 'WheelBTCAU',
        priceStep: 1,
        startValue: 100,
        priceText: "USDT",
        volumeText: "USDT",
        startDate: "05.01.2024",
        content:
          'Стратегия фонда: продажа опционов Put ATM. В случае поставки фьючерсов осуществляется покрытая продажа опционов Call до исполнения и снова продажа опционов Put.',
        info: {
          img: "images/SPUTIBTC.png",
          header: "",
          content: "",
          params: [[
            "Управляющий: Delta трейдер.",
            "Стратегии фонда: среднесрочные трендовые стратегии, а также покупка/продажа волатильности опционов.",
            "Торговые инструменты: фьючерс и опционы на Bitcoin",
            "Вознаграждение управляющего: 15% от прибыли ( shares * (Цена отписки - цена подписки) ) при отписке.",
            "Доп. инфо: доходность фонда формируется за счет временного распада премии проданных опционов. Продажи опционов осуществляются в полном цикле. Риск положительной дельты.",
          ], [
            "Минимальный объем подписки: 100 USDT",
            "Комиссии: Комиссии: при подписке/отписке комиссия не взимается.",
            "Определение цены: ежедневно в 9:10 UTC. LAST = Money / Shares. Где Money текущий лимит средств аккаунта фонда, Shares - объем подписок на фонд.",
            "Заявки на подписку/отписку поданные до 9:10 UTC исполняются до 10:10 UTC по цене LAST определенной в 9:10 UTC. Операции подписки/отписки производятся в понедельник-пятница."
          ]],
          warning: "Внимание! Фонд может иметь существенные риски, вплоть до полной потери средств. Все возможные риски принимает на себя подписчик фонда.",
        },
      },
      {
        img: 'images/AlexTrade.svg',
        imgx: 'right',
        imgy: 'top',
        name: 'FoF',
        header: 'Фонд Фондов',
        priceTicker: 'FoF',
        priceStep: 1,
        startValue: 100,
        priceText: "USDT",
        volumeText: "USDT",
        startDate: "12.06.2025",
        content:
          'Стратегия фонда: диверсифицированный портфель фондов АЕ и готовых стратегий',
        info: {
          img: "images/SPUTIBTC.png",
          header: "",
          content: "",
          params: [[
            "Управляющий: Delta трейдер.",
            "Стратегии фонда: диверсифицированный портфель фондов АЕ и готовых стратегий",
            "Торговые инструменты: фонды и готовые стратегии АЕ. ",
            "Параметры: вознаграждение управляющего 10% от прибыли ( shares * (Цена отписки - цена подписки) ) при отписке.",
          ], [
            "Минимальный объем подписки: 100 USDT.",
            "Комиссии: при подписке/отписке комиссия не взимается.",
            "Определение цены в USDT: ежедневно в 9:10 UTC. LAST = Money / Shares. Где Money текущий лимит средств аккаунта фонда, Shares - объем подписок на фонд. ",
            "Заявки на подписку/отписку поданные до 9:10 UTC исполняются по цене LAST определенной в 9:10 UTC. Операции подписки/отписки производятся в понедельник-пятница."
          ]],
          warning: "Внимание! Фонд может иметь существенные риски, вплоть до полной потери средств. Все возможные риски принимает на себя подписчик фонда. Биржа АЕ не несет никакой ответственности за деятельность управляющего фонда. В случае потери более 50% активов фонда произойдет его ликвидация с отпиской.",
        },
      },
      /*     {
             img: 'images/AlexTrade.svg',
             imgx: 'right',
             imgy: 'top',
             name: 'BTCHODLPlus',
             header: 'Фонд Bitcoin HODL Plus',
             priceTicker: 'BTCHODLPlus',
             priceStep: 0.001,
             startValue: 0.01,
             priceText: "mBTC",
             volumeText: "BTC",
             startDate: "23.01.2024",
             content:
               'Стратегия фонда: покрытые продажи опционов Covered Call на Bitcoin с роллированием.',
             info: {
               img: "images/SPUTIBTC.png",
               header: "",
               content: "",
               params: [[
                 "Управляющий: RentBTC.",
                 "Стратегии фонда: покрытые продажи опционов Covered Call на Bitcoin с роллированием.",
                 "Торговые инструменты: опционы BTC",
                 "Параметры: вознаграждение управляющего 20% от прибыли (High-Water Mark), комиссия за управление 0%, целевая доходность 25-40% годовых.",
                 "Доп. инфо: доходность фонда формируется за счет временного распада премии проданных опционов. Риск исполнения опционов Call в деньгах.",
               ], [
                 "Минимальный объем подписки: 0.01 BTC",
                 "Комиссии: при подписке на фонд, а также при отписке комиссия не взимается. Биржевая комиссия по сделкам фонда стандартная.",
                 "Расчет цены shares производится в mBTC ( 100 000 Satoshi ). Стартовая цена 1 mBTC",
                 "Определение цены: ежедневно в 9:10 UTC. LAST = Money * 1000 / ( BTC index * Shares). Где Money текущий лимит средств аккаунта фонда, Shares - суммарный объем подписок на фонд.",
                 "Заявки на подписку/отписку поданные до 9:10 UTC исполняются до 10:10 UTC по цене LAST определенной в 9:10 UTC. Операции подписки/отписки производятся в понедельник-пятница."
               ]],
               warning: "Внимание! Фонд может иметь существенные риски, вплоть до полной потери средств. Все возможные риски принимает на себя подписчик фонда.",
             },
           },*/
      {
        img: 'images/AlexTrade.svg',
        imgx: 'right',
        imgy: 'top',
        name: 'ReverWheel',
        header: 'Фонд ReverWheel',
        priceTicker: 'ReverWheel',
        priceStep: 0.01,
        startValue: 100,
        priceText: "USDT",
        volumeText: "USDT",
        startDate: "23.05.2024",
        content:
          'Стратегия фонда: Авторская стратегия – Реверсивное Колесо, подразумевает нахождение в господствующем на рынке тренде с двухкратным финансовым плечом, с одновременным сбором распада временной стоимости опционов.',
        info: {
          img: "images/SPUTIBTC.png",
          header: "",
          content: "",
          params: [[
            "Управляющий: Flexo.",
            "Стратегии фонда: Авторская стратегия – Реверсивное Колесо, подразумевает нахождение в господствующем на рынке тренде с двухкратным финансовым плечом, с одновременным сбором распада временной стоимости опционов.",
            "Торговые инструменты: Фьючерсы и опционы на индексы всех криптовалют, торгуемых на бирже АЕ, в равных долях. ",
            "Параметры: вознаграждение управляющего 20% от прибыли (High Water Mark), комиссия за управление 0%, целевая доходность фонда 50-70% годовых",
          ], [
            "Минимальный объем подписки: 100 USDT.",
            "Комиссии: при подписке/отписке комиссия не взимается.",
            "Определение цены: ежедневно в 9:10 UTC. LAST = Money / Shares. Где Money текущий лимит средств аккаунта фонда, Shares - объем подписок на фонд. ",
            "Заявки на подписку, поданные до 9:10 UTC, исполняются до 10:10 UTC по цене LAST определенной в 9:10 UTC. Операции подписки производятся ежедневно.",
            "Заявки на отписку подаются до 20_00 UTC последнего четверга календарного месяца. Фактическая отписка производится в последнюю пятницу месяца до 20_00 UTC."
          ]],
          warning: "Внимание! Фонд может иметь существенные риски, вплоть до полной потери средств. Все возможные риски принимает на себя подписчик фонда.",
        },
      },
      {
        img: 'images/AlexTrade.svg',
        imgx: 'right',
        imgy: 'top',
        name: 'btcASIC',
        header: 'Фонд btcASIC',
        priceTicker: 'btcASIC',
        priceStep: 1,
        startValue: 100,
        priceText: "USDT",
        volumeText: "USDT",
        startDate: "28.11.2024",
        content:
          'Стратегия фонда: добыча крипты без шума ASIC, без затрат на эл. энергию, без амортизации и поломок оборудования.',
        info: {
          img: "images/SPUTIBTC.png",
          header: "",
          content: "",
          params: [[
            "Управляющий: Олег.",
            "Стратегии фонда: добыча крипты без шума ASIC, без затрат на эл. энергию, без амортизации и поломок оборудования.",
            "Торговые инструменты: деривативы ВТС биржи АЕ. ",
            "Параметры: вознаграждение управляющего 10% от прибыли (High Water Mark), комиссия за управление 0%, целевая доходность фонда 30 - 40% годовых.",
          ], [
            "Минимальный объем подписки: 100 USDT.",
            "Комиссии: при подписке/отписке комиссия не взимается.",
            "Определение цены в USDT: ежедневно в 9:10 UTC. LAST = Money / Shares. Где Money текущий лимит средств аккаунта фонда, Shares - объем подписок на фонд. ",
            "Заявки на подписку, поданные до 9:10 UTC, исполняются до 10:10 UTC по цене LAST определенной в 9:10 UTC. Операции подписки производятся ежедневно.",
            "Заявки на отписку подаются до 20_00 UTC последнего четверга календарного месяца. Фактическая отписка производится в последнюю пятницу месяца до 20_00 UTC."
          ]],
          warning: "Внимание! Фонд может иметь существенные риски, вплоть до полной потери средств. Все возможные риски принимает на себя подписчик фонда. Биржа АЕ не несет никакой ответственности за деятельность управляющего фонда. В случае потери более 50% активов фонда произойдет его ликвидация с отпиской.",
        },
      }

      /* {
         img: 'images/AlexTrade.svg',
         imgx: 'right',
         imgy: 'top',
         name: 'ethVAL',
         header: 'Фонд ethVAL',
         priceTicker: 'ethVAL',
         priceStep: 1,
         startValue: 100,
         priceText: "USDT",
         volumeText: "USDT",
         startDate: "12.06.2025",
         content:
           'Стратегия фонда: превзойти в два-три раза доходность валидаторов ETH',
         info: {
           img: "images/SPUTIBTC.png",
           header: "",
           content: "",
           params: [[
             "Управляющий: Олег.",
             "Стратегии фонда: превзойти в два-три раза доходность валидаторов ETH",
             "Торговые инструменты: деривативы ВТС биржи АЕ",
             "Параметры: вознаграждение управляющего 10% от прибыли (High Water Mark), комиссия за управление 0%, целевая доходность фонда 30 - 40% годовых.",
           ], [
             "Минимальный объем подписки: 100 USDT.",
             "Комиссии: при подписке/отписке комиссия не взимается.",
             "Определение цены в USDT: ежедневно в 9:10 UTC. LAST = Money / Shares. Где Money текущий лимит средств аккаунта фонда, Shares - объем подписок на фонд. ",
             "По заявкам на отписку поданным до 20_00 UTC последнего четверга календарного месяца, отписка производится в последнюю пятницу месяца до 20_00 UTC."
           ]],
           warning: "Внимание! Фонд может иметь существенные риски, вплоть до полной потери средств. Все возможные риски принимает на себя подписчик фонда. Биржа АЕ не несет никакой ответственности за деятельность управляющего фонда. В случае потери более 50% активов фонда произойдет его ликвидация с отпиской.",
         },
       },*/


    ]
  },
]
const fundsEng = [
  {
    blockHeader: 'Funds',
    blockItems: [
   /*   {
        img: 'images/AlexTrade.svg',
        imgx: 'right',
        imgy: 'top',
        name: 'BLSW',
        header: 'BLACK SWAN Fund',
        priceTicker: 'BLSW',
        priceStep: 1,
        startValue: 100,
        priceText: "USDT",
        volumeText: "USDT",
        startDate: "2026-02-10",
        content:
          "The fund's strategy is to hunt for a black swan - a rare, unexpected event that causes a strong price movement.",
        info: {
          img: "images/SPUTIBTC.png",
          header: "",
          content: "",
          params: [[
            "Manager: Delta trader.",
            "Fund strategies: volatility traps",
            "Trading instruments: options and Futures",
            "Manager's fee: 20% of profit (High-Water Mark), 0% management fee",
            "Additional info: Fund strategies profit from unexpected price movements (black swan)."
          ], [
            "Minimum subscription volume: 100 USDT",
            "Fees: No subscription/unsubscription fees.",
            "Price determination: weekly at 9:10 UTC. LAST = Money / Shares. Where Money is the current fund account equity limit, and Shares is the fund's subscription volume.",
            "Subscription/unsubscription requests submitted before 9:10 UTC are executed before 10:10 UTC at the LAST price determined at 9:10 UTC. Subscription/unsubscription transactions are processed Monday through Friday."

          ]],
          warning: "Attention! The fund may involve significant risks, including complete loss of funds. All possible risks are assumed by the fund subscriber.",
        },
      }, */

      {
        img: 'images/AlexTrade.svg',
        imgx: 'right',
        imgy: 'top',
        name: 'AlexTrade',
        header: 'AlexTrade Fund',
        priceTicker: 'AlexTrade',
        startDate: "03.03.2023",
        priceStep: 1,
        startValue: 100,
        priceText: "USDT",
        volumeText: "USDT",
        content:
          'Fund Strategies: Medium term trending strategies and buy/sell option volatility. Trading instruments: futures and options on Bitcoin',
        info: {
          img: "images/SPUTIBTC.png",
          header: "BTC Sold Put",
          content: "",
          params: [[
            "Manager: Aleksei Lozitskii, experienced trader.",
            "Fund strategies: medium-term trending strategies, as well as buying / selling option volatility.",
            "Trading instruments: futures and options on Bitcoin",
            "Parameters: manager remuneration 20% of profit (High-Water Mark), management fee 0%, target yield 30-50% per annum.",
            "More info: <a href='https://youtu.be/YqAAGS_cGO8' target='_blank'>video</a> ",
          ], [
            "Minimum subscription amount: 100 USDT",
            "Commissions: when subscribing to the fund, as well as when unsubscribing, no commission is charged. The exchange commission for fund transactions is standard.",
            "Price determination: daily at 9:10 UTC. LAST = Money / Shares. Where Money is the current fund account limit, Shares is the amount of subscriptions to the fund.",
            "Subscribe/unsubscribe orders submitted before 9:10 UTC are executed by 10:10 UTC at the LAST price determined at 9:10 UTC. Subscription/unsubscribe operations are performed on Monday-Friday."
          ]],
          warning: "Attention! The fund may have significant risks, up to the complete loss of funds. All possible risks are assumed by the subscriber of the fund.",
        },
      },
      {
        img: 'images/AlexTrade.svg',
        imgx: 'right',
        imgy: 'top',
        name: 'WheelBTCAU',
        header: 'BTC Wheel ATM (USDT) Fund',
        priceTicker: 'WheelBTCAU',
        startDate: "01.05.2024",
        priceStep: 1,
        startValue: 100,
        priceText: "USDT",
        volumeText: "USDT",
        content:
          'Fund strategy: selling Put ATM options. In the case of delivery of futures, a covered sale of Call options is carried out before exercise and again a sale of Put options.',
        info: {
          img: "images/SPUTIBTC.png",
          header: "",
          content: "",
          params: [[
            "Manager: Delta trader.",
            "Fund strategies: medium-term trend strategies, as well as buying/selling volatility options.",
            "Trading instruments: futures and options on Bitcoin",
            "Manager's remuneration: 15% of profit ( shares * (Unsubscribe price - Subscribe price) ) upon unsubscription.",
            "Additional information: the fund's profitability is formed due to the temporary decay of the premium of sold options. Options are sold in a full cycle. The risk of a positive delta.",
          ], [
            "Minimum subscription volume: 100 USDT",
            "Commissions: when subscribing to the fund, as well as when unsubscribing, no commission is charged. The exchange commission for fund transactions is standard.",
            "Price determination: daily at 9:10 UTC. LAST = Money / Shares. Where Money is the current fund account limit, Shares is the volume of subscriptions to the fund.",
            "Requests for subscription/unsubscription submitted before 9:10 UTC are executed until 10:10 UTC at the LAST price determined at 9:10 UTC. Subscription/unsubscribe operations are carried out on Monday-Friday."
          ]],
          warning: "Attention! The fund may have significant risks, including complete loss of funds. All possible risks are assumed by the fund subscriber.",
        },
      },
      {
        img: 'images/AlexTrade.svg',
        imgx: 'right',
        imgy: 'top',
        name: 'FoF',
        header: 'Fund of Funds',
        priceTicker: 'FoF',
        priceStep: 1,
        startValue: 100,
        priceText: "USDT",
        volumeText: "USDT",
        startDate: "12.06.2025",
        content:
          'Fund strategy: diversified portfolio of AE funds and ready-made strategies',
        info: {
          img: "images/SPUTIBTC.png",
          header: "",
          content: "",
          params: [[
            "Manager: Delta trader.",
            "Fund strategies: diversified portfolio of AE funds and ready-made strategies",
            "Trading instruments: AE funds and ready-made strategies. ",
            "Parameters: manager's fee 10% of profit ( shares * (Unsubscribe price - Subscribe price) ) when unsubscribing.",
          ], [
            "Minimum subscription volume: 100 USDT.",
            "Fees: no fee is charged when subscribing/unsubscribing.",
            "USDT price determination: daily at 9:10 UTC. LAST = Money / Shares. Where Money is the current fund account limit, Shares is the fund subscription volume.",
            "Subscription/unsubscription requests submitted before 9:10 UTC are executed at the LAST price determined at 9:10 UTC. Subscription/unsubscription operations are performed on Monday-Friday."
          ]],
          warning: "Attention! The fund may have significant risks, up to and including the complete loss of funds. All possible risks are assumed by the fund subscriber. AE Exchange does not bear any responsibility for the activities of the fund manager. In the event of a loss of more than 50% of the fund's assets, it will be liquidated with a cancellation.",
        },
      },
      /*   {
           img: 'images/AlexTrade.svg',
           imgx: 'right',
           imgy: 'top',
           name: 'BTCHODLPlus',
           header: 'Bitcoin HODL Plus Fund',
           priceTicker: 'BTCHODLPlus',
           priceStep: 0.001,
           startValue: 0.01,
           priceText: "mBTC",
           volumeText: "BTC",
           startDate: "23.01.2024",
           content:
             'Fund Strategy: covered sales of Covered Call options on Bitcoin with rolling.',
           info: {
             img: "images/SPUTIBTC.png",
             header: "",
             content: "",
             params: [[
               "Manager: RentBTC.",
               "Fund strategies: covered sales of Covered Call options on Bitcoin with rolling.",
               "Trading instruments: BTC options",
               "Parameters: manager's remuneration 20% of profit (High-Water Mark), management fee 0%, target yield 25-40% per annum.",
               "Additional info: the profitability of the fund is formed due to the temporary disintegration of the premium of sold options. The risk of executing Call options in money.",
             ], [
               "Minimum subscription amount: 0.01 BTC",
               "Commissions: when subscribing to the fund, as well as when unsubscribing, no commission is charged. The exchange commission for the fund's transactions is standard.",
               "The shares price is calculated in mBTC ( 100,000 Satoshi ). The starting price is 1 mBTC",
               "Price determination: daily at 9:10 UTC. LAST = Money * 1000 / ( BTC index * Shares). Where Money is the current limit of the fund's account, Shares is the total volume of subscriptions to the fund.",
               "Subscription/unsubscribe requests submitted before 9:10 UTC are executed before 10:10 UTC at the LAST price determined at 9:10 UTC. Subscription/unsubscription operations are performed on Monday-Friday."
             ]],
             warning: "Attention! The Fund may have significant risks, up to a complete loss of funds. All possible risks are assumed by the subscriber of the fund.",
           },
         },*/
      {
        img: 'images/AlexTrade.svg',
        imgx: 'right',
        imgy: 'top',
        name: 'ReverWheel',
        header: 'ReverWheel Fund',
        priceTicker: 'ReverWheel',
        priceStep: 0.01,
        startValue: 100,
        priceText: "USDT",
        volumeText: "USDT",
        startDate: "23.05.2024",
        content:
          "Fund strategy: Author's strategy - Reverse Wheel, implies being in the prevailing market trend with a two-fold financial leverage, while simultaneously collecting the decay in the time value of options.",
        info: {
          img: "images/SPUTIBTC.png",
          header: "",
          content: "",
          params: [[
            "Manager: Flexo.",
            "Fund strategies: Author's strategy - Reverse Wheel, implies being in the prevailing market trend with a two-fold financial leverage, while simultaneously collecting the decay in the time value of options.",
            "Trading instruments: Futures and options on indices of all cryptocurrencies traded on the AE exchange, in equal shares.",
            "Parameters: manager's remuneration 20% of profit (High Water Mark), management fee 0%, target fund return 50-70% per annum",
          ], [
            "Minimum subscription volume: 100 USDT.",
            "Commissions: when subscribing to the fund, as well as when unsubscribing, no commission is charged. The exchange commission for fund transactions is standard.",
            "Price determination: daily at 9:10 UTC. LAST = Money / Shares. Where Money is the current fund account limit, Shares is the volume of subscriptions to the fund.",
            "Subscription requests submitted before 9:10 UTC are executed until 10:10 UTC at the LAST price determined at 9:10 UTC. Subscription operations are carried out daily.",
            "Requests for unsubscription are submitted before 20_00 UTC on the last Thursday of the calendar month. Actual unsubscription is made on the last Friday of the month before 20_00 UTC."
          ]],
          warning: "Attention! The fund may have significant risks, up to complete loss of funds. All possible risks are assumed by the fund subscriber.",
        },
      },
      {
        img: 'images/AlexTrade.svg',
        imgx: 'right',
        imgy: 'top',
        name: 'btcASIC',
        header: 'btcASIC Fund',
        priceTicker: 'btcASIC',
        priceStep: 1,
        startValue: 100,
        priceText: "USDT",
        volumeText: "USDT",
        startDate: "28.11.2024",
        content:
          "Fund strategies: crypto mining without ASIC noise, without electricity costs, without depreciation and equipment breakdowns.",
        info: {
          img: "images/SPUTIBTC.png",
          header: "",
          content: "",
          params: [[
            "Manager: Oleg.",
            "Fund strategies: crypto mining without ASIC noise, without electricity costs, without depreciation and equipment breakdowns.",
            "Trading instruments: BTC derivatives of the AE exchange. ",
            "Parameters: manager's remuneration is 10% of profit (High Water Mark), management fee is 0%, target fund yield is 30-40% per annum.",
          ], [
            "Minimum subscription volume: 100 USDT.",
            "Commissions: when subscribing to the fund, as well as when unsubscribing, no commission is charged. The exchange commission for fund transactions is standard.",
            "Price determination in USDT: daily at 9:10 UTC. LAST = Money / Shares. Where Money is the current limit of the fund account, Shares is the volume of subscriptions to the fund. ",
            "Subscription requests submitted before 9:10 UTC are executed before 10:10 UTC at the LAST price determined at 9:10 UTC. Subscription transactions are performed daily.",
            "Unsubscribe requests are submitted before 20_00 UTC on the last Thursday of the calendar month. The actual unsubscription is performed on the last Friday of the month before 20_00 UTC."
          ]],
          warning: "Attention! The fund may have significant risks, up to and including the complete loss of funds. All possible risks are assumed by the fund subscriber. AE Exchange does not bear any responsibility for the activities of the managing fund. In the event of a loss of more than 50% of the fund's assets, it will be liquidated with unsubscription.",
        },
      }

      /*  {
          img: 'images/AlexTrade.svg',
          imgx: 'right',
          imgy: 'top',
          name: 'ethVAL',
          header: 'ethVAL Fund',
          priceTicker: 'ethVAL',
          priceStep: 1,
          startValue: 100,
          priceText: "USDT",
          volumeText: "USDT",
          startDate: "2025-06-12",
          content:
            'Fund strategy: exceed the yield of ETH validators by two to three times',
          info: {
            img: "images/SPUTIBTC.png",
            header: "",
            content: "",
            params: [[
              "Manager: Oleg.",
              "Fund strategies: exceed the yield of ETH validators by two to three times",
              "Trading instruments: BTC derivatives AE exchanges",
              "Parameters: manager's fee is 10% of profit (High Water Mark), management fee is 0%, target fund yield is 30-40% per annum.",
            ], [
              "Minimum subscription volume: 100 USDT.",
              "Commissions: no commission is charged for subscription/unsubscription.",
              "Price determination in USDT: daily at 9:10 UTC. LAST = Money / Shares. Where Money is the current limit of the fund account, Shares is the volume of subscriptions to the fund. ",
              "For unsubscription requests submitted before 20_00 UTC on the last Thursday of the calendar month, the unsubscription is made on the last Friday of the month before 20_00 UTC."]],
            warning: "Attention! The fund may have significant risks, up to and including the complete loss of funds. All possible risks are assumed by the fund subscriber. AE Exchange does not bear any responsibility for the activities of the fund manager. In the event of a loss of more than 50% of the fund's assets, it will be liquidated with a cancellation.",
          },
        },*/

    ]
  }
]
const strateges = [
  {
    //  blockHeader: 'Инвестору',
    blockHeader: '',
    blockItems: [
      {
        img: 'images/SPUTIBTC.svg',
        imgx: 'right',
        imgy: 'top',
        name: 'SPUTIGOLD',
        header: 'Проданный пут GOLD ',
        priceTicker: 'SPUTIGOLD',
        startDate: "29.10.2025",
        minShares: 100,
        priceText: "USDT",
        content:
          'Стратегия получает прибыль за счет временного распада проданных опционов Put и положительной дельты по GOLD',
        info: {
          img: "images/SPUTIBTC.png",
          header: "Проданный пут GOLD",
          content: "",
          params: [[
            "Опционы: месячной серии",
            "Страйки: в деньгах с дельта 0,65-0,75",
            "Лонгирование: в следующую месячную серию за неделю до экспирации текущей серии опционов",
            "Маржинальные требования: под маржинальные требования (GM) используется до 80% всех средств стратегии",
            "Определение цены :  ежедневно в 9:10 UTC. LAST = Money / Shares. Где Money текущий лимит средств аккаунта стратегии, Shares - количество подписок на стратегию",
            "Риск стратегии: снижении цены GOLD фьючерса при котором премия опциона пут не покроет полученный убыток"
          ], [
            "Минимальный объем подписки: 100 USDT",
            "Комиссии: при подписке на стратегию комиссия не взимается. При отписке взимается комиссия в размере 10% от положительного PnL подписки.",
            "Заявки на подписку/отписку поданные до 9:10 UTC исполняются до 10:10 UTC по цене LAST определенной в 9:10 UTC."
          ]],
          warning: "Внимание! Стратегия может иметь существенные риски, вплоть до полной потери средств. Все возможные риски принимает на себя подписчик стратегии.",

        }
      },
      {
        img: 'images/SPUTIBTC.svg',
        imgx: 'right',
        imgy: 'top',
        name: 'SPUTIBTC',
        header: 'Проданный пут BTC',
        priceTicker: 'SPUTIBTC',
        startDate: "08.07.2022",
        minShares: 100,
        priceText: "USDT",
        content:
          'Стратегия направлена на долгосрочное получение прибыли за счет постоянной продажи премии опциона пут в деньгах и положительной дельты по биткоин фьючерсу.',
        info: {
          img: "images/SPUTIBTC.png",
          header: "Проданный пут  BTC",
          content: "",
          params: [[
            "Опционы: месячной серии на фьючерс BTC",
            "Страйки: в деньгах с дельта 0,65-0,75",
            "Лонгирование: в следующую месячную серию за неделю до экспирации текущей серии опционов",
            "Маржинальные требования: под маржинальные требования (GM) используется до 80% всех средств стратегии",
            "Определение цены SPUTIBTC: ежедневно в 9:10 UTC. LAST = Money / Shares. Где Money текущий лимит средств аккаунта стратегии, Shares - количество подписок на инструмент SPUTIBTC",
            "Риск стратегии: снижении цены BTC фьючерса при котором премия опциона пут не покроет полученный убыток"
          ], [
            "Минимальный объем подписки: 100 USDT",
            "Комиссии: при подписке на стратегию комиссия не взимается. При отписке взимается комиссия в размере 10% от положительного PnL подписки.",
            "Заявки на подписку/отписку поданные до 9:10 UTC исполняются до 10:10 UTC по цене LAST определенной в 9:10 UTC."
          ]],
          warning: "Внимание! Стратегия может иметь существенные риски, вплоть до полной потери средств. Все возможные риски принимает на себя подписчик стратегии.",

        }
      },
      /*  {
          img: 'images/untitled.svg',
          imgx: 'right',
          imgy: 'top',
          name: 'DEPOUSDT',
          header: 'Deposit USDT',
          priceTicker: 'DEPOUSDT',
          startDate: "18.03.2025",
          minShares: 100,
          priceText: "USDT",
          content:
            'Стратегия обеспечивает доходность USDT за счет получения фандинга фьючерсов. ',
          info: {
            img: "images/DEPOUSDT.",
            header: "Deposit USDT",
            content: "",
            params: [[
              "Уровень доходности стратегии зависит от размера фандинга крипто фьючерсов и безрисковой ставки USD.",
              "Определение цены стратегии: ежедневно в 9:10 UTC. LAST = Money / Shares. Где Money текущий лимит средств аккаунта стратегии, Shares - количество подписок",
              "Риск стратегии: сильный рост фандинга фьючерсов"
            ], [
              "Минимальный объем подписки: 100 USDT",
              "Комиссии: при подписке на стратегию комиссия не взимается. При отписке взимается комиссия в размере 10% от положительного PnL подписки.",
              "Заявки на подписку/отписку поданные до 9:10 UTC исполняются до 10:10 UTC по цене LAST определенной в 9:10 UTC."
            ]],
            warning: "Внимание! Стратегия может иметь существенные риски, вплоть до полной потери средств. Все возможные риски принимает на себя подписчик стратегии.",
  
          }
  
        },*/
      {
        img: 'images/SPUTIBTC.svg',
        imgx: 'right',
        imgy: 'top',
        name: 'SPUTICRYPTO',
        header: 'Проданные путы BTC ETH DOGE TON SOLANA XRP',
        priceTicker: 'SPUTICRYPTO',
        startDate: "12.07.2023",
        minShares: 100,
        priceText: "USDT",
        content:
          'Стратегия направлена на долгосрочное получение прибыли за счет постоянной продажи премии опционов пут в деньгах и положительной дельты крипто фьючеров.',
        info: {
          img: "images/SPUTIBTC.png",
          header: "Проданные путы BTC ETH DOGE TON SOLANA XRP",
          content: "Консервативная инвест стратегия на корзину криптовалют использует плюсы продажи ITM PUT опционов и получении Cash Flow от распада их временной премии.",
          params: [[
            "Опционы: продажи опционов PUT месячных серий на фьючерсы в долях BTC (30%) ETH (20%) DOGE (10%) TON (10%) SOLANA (15%) XRP (15%)",
            "Страйки: в деньгах, дельта 0,65-0,75",
            "Лонгирование: в следующую месячную серию за неделю до экспирации текущей серии опционов",
            "Плечо стратегии: x1 (без плеча)",
            "Определение цены: ежедневно в 9:10 UTC. LAST = Money / Shares. Где Money текущий лимит средств аккаунта стратегии, Shares - количество подписок на инструмент SPUTICRYPTO",
            "Риск стратегии: снижении цен фьючерсов при котором премии опционов пут не покроют полученный убыток",
          ], [
            "Минимальный объем подписки: 100 USDT .",
            "Комиссии: при подписке на стратегию комиссия не взимается. При отписке взимается комиссия в размере 10% от положительного PnL подписки.",
            "Заявки на подписку/отписку поданные до 9:10 UTC исполняются до 10:10 UTC по цене LAST определенной в 9:10 UTC."
          ]],
          warning: "Внимание! Стратегия может иметь существенные риски, вплоть до полной потери средств. Все возможные риски принимает на себя подписчик стратегии.",

        },
      },
      {
        img: 'images/SPUTIBTC.svg',
        imgx: 'right',
        imgy: 'top',
        name: 'SPUTIETH',
        header: 'Проданный пут ETH ',
        priceTicker: 'SPUTIETH',
        startDate: "22.07.2022",
        minShares: 100,
        priceText: "USDT",
        content:
          'Стратегия направлена на долгосрочное получение прибыли за счет постоянной продажи премии опциона пут в деньгах и положительной дельты по эфириум фьючерсу.',
        info: {
          img: "images/SPUTIBTC.png",
          header: "Проданный пут  ETH ",
          content: "",
          params: [[
            "Опционы: месячной серии на фьючерс ETH",
            "Страйки: в деньгах с дельта 0,65-0,75",
            "Лонгирование: в следующую месячную серию за неделю до экспирации текущей серии опционов",
            "Маржинальные требования: под маржинальные требования (GM) используется до 80% всех средств стратегии",
            "Определение цены SPUTIETH: ежедневно в 9:10 UTC. LAST = Money / Shares. Где Money текущий лимит средств аккаунта стратегии, Shares - количество подписок на инструмент SPUTIETH",
            "Риск стратегии: снижении цены ETH фьючерса при котором премия опциона пут не покроет полученный убыток"
          ], [
            "Минимальный объем подписки: 100 USDT",
            "Комиссии: при подписке на стратегию комиссия не взимается. При отписке взимается комиссия в размере 10% от положительного PnL подписки.",
            "Заявки на подписку/отписку поданные до 9:10 UTC исполняются до 10:10 UTC по цене LAST определенной в 9:10 UTC."
          ]],
          warning: "Внимание! Стратегия может иметь существенные риски, вплоть до полной потери средств. Все возможные риски принимает на себя подписчик стратегии.",

        }
      },

    /*  {
        img: 'images/SPUTIBTC.svg',
        imgx: 'right',
        imgy: 'top',
        name: 'SPUTITON',
        header: 'Проданный пут TON',
        priceTicker: 'SPUTITON',
        startDate: "23.09.2024",
        minShares: 100,
        priceText: "USDT",
        content:
          'Стратегия направлена на долгосрочное получение прибыли за счет постоянной продажи премии опционов пут в деньгах и положительной дельты.',
        info: {
          img: "images/SPUTIBTC.png",
          header: "Проданный пут TON",
          content: "",
          params: [[
            "Опционы: месячной серии на фьючерс TON ( Toncoin )",
            "Страйки: в деньгах с дельта 0,65-0,75",
            "Леверидж: х2",
            "Лонгирование: в следующую месячную серию за неделю до экспирации текущей серии опционов",
            "Определение цены: ежедневно в 9:10 UTC. LAST = Money / Shares. Где Money текущий лимит средств аккаунта стратегии, Shares - количество подписок",
            "Риск стратегии: значительное падение цены фьючерса TON",
          ], [
            "Минимальный объем подписки: 100 USDT",
            "Комиссии: при подписке на стратегию комиссия не взимается. При отписке взимается комиссия в размере 10% от положительного PnL подписки.",
            "Заявки на подписку/отписку поданные до 9:10 UTC исполняются до 10:10 UTC по цене LAST определенной в 9:10 UTC."
          ]],
          warning: "Внимание! Стратегия может иметь существенные риски, вплоть до полной потери средств. Все возможные риски принимает на себя подписчик стратегии.",

        },
      },
      {
        img: 'images/SPUTIBTC.svg',
        imgx: 'right',
        imgy: 'top',
        name: 'SPUTISOL',
        header: 'Проданный пут SOLANA',
        priceTicker: 'SPUTISOL',
        startDate: "04.06.2024",
        minShares: 100,
        priceText: "USDT",
        content:
          'Стратегия направлена на долгосрочное получение прибыли за счет постоянной продажи премии опционов пут в деньгах и положительной дельты по SOLANA фьючерсу.',
        info: {
          img: "images/SPUTIBTC.png",
          header: "Проданный пут SOLANA",
          content: "Стратегия направлена на долгосрочное получение прибыли за счет постоянной продажи премии опционов пут в деньгах и положительной дельты по SOLANA фьючерсу.",
          params: [[
            "Опционы: месячной серии на фьючерс SOL ( SOLANA )",
            "Страйки: в деньгах, дельта 0,65-0,75",
            "Леверидж: х2",
            "Лонгирование: в следующую месячную серию за неделю до экспирации текущей серии опционов",
            "Определение цены: ежедневно в 9:10 UTC. LAST = Money / Shares. Где Money текущий лимит средств аккаунта стратегии, Shares - количество подписок",
            "Риск стратегии: значительное падение цены фьючерса SOL",
          ], [
            "Минимальный объем подписки: 100 USDT.",
            "Комиссии: при подписке на стратегию, а также при отписке комиссия не взимается. При совершении трейдов применяется повышенная комиссия биржи.",
            "Заявки на подписку/отписку поданные до 9:10 UTC исполняются до 10:10 UTC по цене LAST определенной в 9:10 UTC."
          ]],
          warning: "Внимание! Стратегия может иметь существенные риски, вплоть до полной потери средств. Все возможные риски принимает на себя подписчик стратегии.",

        },
      },*/

      /* {
         img: 'images/SPUTIBTC.svg',
         imgx: 'right',
         imgy: 'top',
         name: 'SPUTIMATIC',
         header: 'Проданный пут MATIC',
         priceTicker: 'SPUTIMATIC',
         startDate: "22.02.2023",
         minShares: 100,
         priceText: "USDT",
         content:
           'Стратегия направлена на долгосрочное получение прибыли за счет постоянной продажи премии опциона пут в деньгах и положительной дельты по MATIC фьючерсу.',
         info: {
           img: "images/SPUTIBTC.png",
           header: "Проданный пут  MATIC",
           content: "",
           params: [[
             "Опционы: месячной серии на фьючерс MATIC",
             "Страйки: в деньгах с дельта 0,65-0,75",
             "Леверидж: х2",
             "Лонгирование: в следующую месячную серию за неделю до экспирации текущей серии опционов",
             "Маржинальные требования: под маржинальные требования (GM) используется до 80% всех средств стратегии",
             "Определение цены: ежедневно в 9:10 UTC. LAST = Money / Shares. Где Money текущий лимит средств аккаунта стратегии, Shares - количество подписок",
             "Риск стратегии: значительное падение цены фьючерса опционов",
           ], [
             "Минимальный объем подписки: 100 USDT",
             "Комиссии: при подписке на стратегию, а также при отписке комиссия не взимается. При совершении трейдов применяется повышенная комиссия биржи.",
             "Заявки на подписку/отписку поданные до 9:10 UTC исполняются до 10:10 UTC по цене LAST определенной в 9:10 UTC."
           ]],
           warning: "Внимание! Стратегия может иметь существенные риски, вплоть до полной потери средств. Все возможные риски принимает на себя подписчик стратегии.",
 
         },
       },*/
    ]
  },
  /* {
     blockHeader: 'Спекулянту',
     blockItems: [
       {
         img: 'images/SIVBTC.svg',
         imgx: 'right',
         imgy: 'top',
         name: 'SIVBTC',
         header: 'Продажа волатильности опционов BTC',
         priceTicker: 'SIVBTC',
         startDate: "02.08.2022",
         minShares: 100,
         priceText: "USDT",
         content:
           'Sell IV BTC стратегия продажи IV опционов на биткоин фьючерс, приносит прибыль при снижении волатильности опционов IV, а также от временного распада проданных опционов.',
         info: {
           img: "images/SIVBTC.png",
           header: "Продажа волатильности опционов BTC",
           content: "",
           params: [[
             "Опционы: месячной серии на фьючерс BTC",
             "Страйки: опционы центрального страйка",
             "Хеджирование: роботом Дельта хеджер с удержанием около нейтральной дельта позиции. Расчет дельта позиции осуществляется по биржевой IV опционов.",
             "Роллирование: опционы роллируются на центральный страйк при выходе дельта опциона из диапазона 0,35-0,7",
             "Лонгирование: в следующую месячную серию за неделю до экспирации текущей серии опционов",
             "Маржинальные требования: базовый уровень GM 20%",
             "Определение цены SIVBTC: ежедневно в 9:10 UTC. LAST = Money / Shares. Где Money текущий лимит средств аккаунта стратегии, Shares - количество подписок на инструмент SIVBTC",
             "Риск стратегии: значительный рост IV опционов и рост стоимости дельта хеджирования."
           ], [
             "Минимальный объем подписки: 100 USDT",
             "Комиссии: при подписке на стратегию, а также при отписке комиссия не взимается. При совершении трейдов применяется повышенная комиссия биржи.",
             "Заявки на подписку/отписку поданные до 9:10 UTC исполняются до 10:10 UTC по цене LAST определенной в 9:10 UTC."
           ]],
           warning: "Внимание! Стратегия может иметь существенные риски, вплоть до полной потери средств. Все возможные риски принимает на себя подписчик стратегии.",
 
         }
       },
       {
         img: 'images/BuyIVBTC.svg',
         imgx: 'right',
         imgy: 'top',
         name: 'BuyIVBTC',
         header: 'Покупка волатильности опционов BTC',
         priceTicker: 'BuyIVBTC',
         startDate: "09.08.2022",
         minShares: 100,
         content:
           'Buy IV BTC стратегия покупки IV опционов на биткоин фьючерс, приносит прибыль при росте волатильности  опционов IV и роста реализуемой волатильности RV фьючерса Bitcoin. Long straddle.',
         info: {
           img: "images/BuyIVBTC.png",
           header: "Покупка волатильности опционов BTC",
           content: "",
           params: [[
             "Опционы: месячной серии на фьючерс BTC",
             "Страйки: опционы центрального страйка",
             "Дельта хеджирование: роботом ReHedger с удержанием около нейтральной дельта позиции. ",
             "Расчет дельта позиции осуществляется по биржевой IV опционов.",
             "Роллирование: опционы роллируются на центральный страйк при выходе дельта опциона из диапазона 0,35-0,7",
             "Лонгирование: в следующую месячную серию за неделю до экспирации текущей серии опционов",
             "Маржинальные требования: базовый уровень GM 20%",
             "Определение цены BuyIVBTC: ежедневно в 9:10 UTC. LAST = Money / Shares. Где Money текущий лимит средств аккаунта стратегии, Shares - количество подписок на инструмент BuyIVBTC",
             "Риск стратегии: снижение IV опционов и реализуемой волатильности RV, временной распад премий опционов."
           ], [
             "Минимальный объем подписки: 100 USDT",
             "Комиссии: при подписке на стратегию, а также при отписке комиссия не взимается. При совершении трейдов применяется повышенная комиссия биржи.",
             "Заявки на подписку/отписку поданные до 9:10 UTC исполняются до 10:10 UTC по цене LAST определенной в 9:10 UTC."
           ]],
           warning: "Внимание! Стратегия может иметь существенные риски, вплоть до полной потери средств. Все возможные риски принимает на себя подписчик стратегии.",
 
         }
       }
     ]
   },*/
  /* {
     blockHeader: 'Майнеру',
     blockItems: [*/
  /*{
    img: 'images/HeBTC.svg',
    imgx: 'right',
    imgy: 'top',
    name: 'HedgeBTC',
    header: 'Хеджирование BTC',
    priceTicker: 'HedgeBTC',
    content:
      'Стратегия защиты от сильного падения цены биткоин покупкой put опционов  OTM.',
    info: {
      img: "images/HeBTC.png",
      header: "Хеджирование BTC",
      content: "",
      params: [[
        "Опционы: put месячной серии на фьючерс BTC",
        "Страйки: вне денег с дельтой 0,1-0,2",
        "Лонгирование: в следующую месячную серию за неделю до экспирации текущей серии опционов",
        "Плечо на экспозицию фьючерса: x20",
        "Определение цены: ежедневно в 9:10 UTC. LAST = Money / Shares. Где Money текущий лимит средств аккаунта стратегии, Shares - количество подписок по cтратегии",
        "Риск стратегии: обесценение купленных опционов Put"
      ], [
        "Минимальный объем подписки: 100 USDT",
        "Комиссии: при подписке на стратегию комиссия составляет 0% (ноль) от объема подписки, при отписки комиссия не взимается.",
        "Заявки на подписку/отписку поданные до 9:10 UTC исполняются до 10:10 UTC по цене LAST определенной в 9:10 UTC."
      ]],
      warning: "Внимание! Стратегия может иметь существенные риски, вплоть до полной потери средств. Все возможные риски принимает на себя подписчик стратегии.",

    },
  },*/
  /*   {
       img: 'images/HeBTCPlus.svg',
       imgx: 'right',
       imgy: 'top',
       name: 'HedgeBTCPlus',
       header: 'Хеджирование BTC Plus',
       priceTicker: 'HedgeBTCPlus',
       startDate: "01.09.2022",
       minShares: 100,
       content:
         'Продвинутая Стратегия защиты от сильного падения цены биткоин покупкой put опционов и продажей Call опционов  OTM. Стратегия дает возможность получить страховку бесплатно.',
       info: {
         img: "images/HeBTCPlus.png",
         header: "Хеджирование BTC Plus",
         content: "",
         params: [[
           "Опционы: put и call месячной серии на фьючерс BTC",
           "Страйки: дельта 0,15-0,3",
           "Лонгирование: в следующую месячную серию за неделю до экспирации текущей серии опционов",
           "Плечо на экспозицию фьючерса: 1x",
           "Определение цены: ежедневно в 9:10 UTC. LAST = Money / Shares. Где Money текущий лимит средств аккаунта стратегии, Shares - количество подписок по cтратегии",
           "Риск стратегии: значительный рост цены фьючерса BTC при отсутствии Bitcoin покрытия в полном объеме."
         ], [
           "Минимальный объем подписки: 100 USDT",
           "Комиссии: при подписке на стратегию, а также при отписке комиссия не взимается. При совершении трейдов применяется повышенная комиссия биржи.",
           "Заявки на подписку/отписку поданные до 9:10 UTC исполняются до 10:10 UTC по цене LAST определенной в 9:10 UTC."
         ]],
         warning: "Внимание! Стратегия может иметь существенные риски, вплоть до полной потери средств. Все возможные риски принимает на себя подписчик стратегии.",
 
       },
     },*/
  /*   ]
   },*/
]
//Engl
const strategesEng =
  [
    {
      blockHeader: 'Investor',
      blockItems: [
        {
          img: 'images/SPUTIBTC.svg',
          imgx: 'right',
          imgy: 'top',
          name: 'SPUTIGOLD',
          header: 'Sold GOLD Put',
          priceTicker: 'SPUTIGOLD',
          startDate: "29.10.2025",
          minShares: 100,
          priceText: "USDT",
          content:
            'The strategy profits from the time decay of sold Put options and positive delta on GOLD',
          info: {
            img: "images/SPUTIBTC.png",
            header: "Sold GOLD Put",
            content: "",
            params: [[
              "Options: monthly series",
              "Strikes: in-the-money with delta 0.65-0.75",
              "Longing: next Monthly series one week before the expiration of the current option series",
              "Margin requirements: Up to 80% of the strategy's total funds are used for margin requirements (GM)",
              "Price determination: daily at 9:10 UTC. LAST = Money / Shares. Where Money is the current equity limit of the strategy account, and Shares is the number of subscriptions to the strategy",
              "Strategy risk: a decrease in the price of the GOLD futures contract, in which the put option premium does not cover the resulting loss"
            ], [
              "Minimum subscription volume: 100 USDT",
              "Commissions: There is no commission when subscribing to the strategy. When unsubscribing, a commission of 10% of the positive PnL of the subscription is charged.",
              "Subscription/unsubscription requests submitted before 9:10 UTC are executed before 10:10 UTC at the LAST price determined at 9:10 UTC."
            ]],
            warning: "Attention! This strategy may involve significant risks, including complete loss of funds. The subscriber to the strategy assumes all possible risks.",

          }
        },
        {
          img: 'images/SPUTIBTC.svg',
          imgx: 'right',
          imgy: 'top',
          name: 'SPUTIBTC',
          header: 'Sold put BTC',
          priceTicker: 'SPUTIBTC',
          startDate: "08.07.2022",
          minShares: 100,
          priceText: "USDT",
          content:
            'The strategy aims to make a long-term profit through the constant sale of put option premium in the money and a positive delta on bitcoin futures.',
          info: {
            img: "images/SPUTIBTC.png",
            header: "BTC Puts Sold",
            content: "",
            params: [[
              "Options: monthly series on BTC futures",
              "Strikes: in the money with a delta of 0.65-0.75",
              "Longing: to the next monthly series one week before the expiration of the current option series",
              "Margin requirements: up to 80% of all strategy funds are used for margin requirements (GM)",
              "SPUTIBTC price determination: daily at 9:10 UTC. LAST = Money / Shares. Where Money is the current limit of funds of the strategy account, Shares is the number of subscriptions to the SPUTIBTC instrument",
              "Strategy risk: a decrease in the price of BTC futures in which the premium of the put option does not cover the resulting loss"
            ], [
              "Minimum subscription amount: 100 USDT",
              "Commissions: There is no commission when subscribing to a strategy. When unsubscribing, a commission of 10% of the positive PnL of the subscription is charged.",
              "Subscribe/unsubscribe orders submitted before 9:10 UTC are executed by 10:10 UTC at the LAST price determined at 9:10 UTC."
            ]],
            warning: "Attention! The strategy may have significant risks, up to the complete loss of funds. All possible risks are assumed by the subscriber of the strategy.",

          }
        },
        /*   {
             img: 'images/SPUTIBTC.svg',
             imgx: 'right',
             imgy: 'top',
             name: 'DEPOUSDT',
             header: 'Deposit USDT',
             priceTicker: 'DEPOUSDT',
             startDate: "18.03.2025",
             minShares: 100,
             priceText: "USDT",
             content:
               'The strategy ensures USDT profitability by receiving futures funding. ',
             info: {
               img: "",
               header: "Deposit USDT",
               content: "",
               params: [[
                 "The strategy's profitability level depends on the size of crypto futures funding and the USD risk-free rate.",
                 "Strategy price determination: daily at 9:10 UTC. LAST = Money / Shares. Where Money is the current limit of funds in the strategy account, Shares is the number of subscriptions",
                 "Strategy risk: strong growth in futures funding"
               ], [
                 "Minimum subscription volume: 100 USDT",
                 "Commissions: There is no commission when subscribing to a strategy. When unsubscribing, a commission of 10% of the positive PnL of the subscription is charged.",
                 "Subscription/unsubscription requests submitted before 9:10 UTC are executed before 10:10 UTC at the LAST price determined at 9:10 UTC."]],
               warning: "Attention! The strategy may have significant risks, up to and including the complete loss of funds. All possible risks are assumed by the subscriber of the strategy.",
   
             }
   
           },*/
        {
          img: 'images/SPUTIBTC.svg',
          imgx: 'right',
          imgy: 'top',
          name: 'SPUTIETH',
          header: 'Sold put ETH ',
          priceTicker: 'SPUTIETH',
          startDate: "22.07.2022",
          minShares: 100,
          priceText: "USDT",
          content:
            'The strategy aims to generate long-term profits through the constant selling of the put premium in the money and a positive delta on Ethereum futures.',
          info: {
            img: "images/SPUTIBTC.png",
            header: "Sold put ETH",
            content: "",
            params: [[
              "Options: monthly series on ETH futures",
              "Strikes: in the money with a delta of 0.65-0.75",
              "Longing: to the next monthly series one week before the expiration of the current option series",
              "Margin requirements: up to 80% of all strategy funds are used for margin requirements (GM)",
              "SPUTIETH price determination: daily at 9:10 UTC. LAST = Money / Shares. Where Money is the current strategy account equity limit, Shares is the number of subscriptions to the SPUTIETH tool",
              "Strategy risk: a decrease in the price of the ETH futures, in which the premium of the put option does not cover the resulting loss"
            ], [
              "Minimum subscription amount: 100 USDT",
              "Commissions: There is no commission when subscribing to a strategy. When unsubscribing, a commission of 10% of the positive PnL of the subscription is charged.",
              "Subscribe/unsubscribe orders submitted before 9:10 UTC are executed by 10:10 UTC at the LAST price determined at 9:10 UTC."
            ]],
            warning: "Attention! The strategy may have significant risks, up to the complete loss of funds. All possible risks are assumed by the subscriber of the strategy.",

          }
        },
       /* {
          img: 'images/SPUTIBTC.svg',
          imgx: 'right',
          imgy: 'top',
          name: 'SPUTISOL',
          header: 'Sold put SOLANA',
          priceTicker: 'SPUTISOL',
          startDate: "04.06.2024",
          minShares: 100,
          priceText: "USDT",
          content:
            'The strategy is aimed at long-term profit-making by constantly selling in-the-money put option premium and positive delta on SOLANA futures.',
          info: {
            img: "images/SPUTIBTC.png",
            header: "Sold put SOLANA",
            content: "The strategy is aimed at long-term profit-making by constantly selling in-the-money put option premium and positive delta on SOLANA futures.",
            params: [[
              "Options: monthly series on SOL futures ( SOLANA )",
              "Strikes: in the money, delta 0.65-0.75",
              "Leverage: x2",
              "Longing: into the next monthly series a week before the expiration of the current options series",
              "Price determination: daily at 9:10 UTC. LAST = Money / Shares. Where Money is the current limit of funds in the strategy account, Shares is the number of subscriptions",
              "Strategy risk: significant drop in the price of SOL futures",
            ], [
              "Minimum subscription volume: 100 USDT.",
              "Commissions: There is no commission when subscribing to a strategy. When unsubscribing, a commission of 10% of the positive PnL of the subscription is charged.",
              "Subscription/unsubscription requests submitted before 9:10 UTC are executed before 10:10 UTC at the LAST price determined at 9:10 UTC."
            ]],
            warning: "Attention! The strategy may have significant risks, up to and including the complete loss of funds. All possible risks are assumed by the subscriber of the strategy.",

          },
        },*/

        {
          img: 'images/SPUTIBTC.svg',
          imgx: 'right',
          imgy: 'top',
          name: 'SPUTICRYPTO',
          header: 'Sold puts BTC ETH DOGE TON SOLANA XRP',
          priceTicker: 'SPUTICRYPTO',
          startDate: "12.07.2023",
          minShares: 100,
          priceText: "USDT",
          content:
            'The strategy aims to generate long-term profits through the constant selling of premium in-the-money put options and a positive delta of crypto futures.',
          info: {
            img: "images/SPUTIBTC.png",
            header: "Sold puts BTC ETH DOGE TON SOLANA XRP",
            content: "A conservative investment strategy for a basket of cryptocurrencies uses the advantages of selling ITM PUT options and receiving Cash Flow from the collapse of their temporary premium.",
            params: [[
              "Options: selling PUT options of monthly series on futures in shares of BTC (30%) ETH (20%) DOGE (10%) TON (10%) SOLANA (15%) XRP (15%)",
              "Strikes: in the money, delta 0.65-0.75",
              "Longing: into the next monthly series a week before the expiration of the current options series",
              "Strategy leverage: x1 (no leverage)",
              "Price determination: daily at 9:10 UTC. LAST = Money / Shares. Where Money is the current limit of funds in the strategy account, Shares is the number of subscriptions to the SPUTICRYPTO instrument",
              "Strategy risk: a decrease in futures prices in which put option premiums will not cover the resulting loss",
            ], [
              "Minimum subscription volume: 100 USDT .",
              "Commissions: There is no commission when subscribing to a strategy. When unsubscribing, a commission of 10% of the positive PnL of the subscription is charged.",
              "Subscription/unsubscription requests submitted before 9:10 UTC are executed before 10:10 UTC at the LAST price determined at 9:10 UTC."
            ]],
            warning: "Attention! The strategy may have significant risks, up to the complete loss of funds. All possible risks are assumed by the subscriber of the strategy.",

          },
        },
/*        {
          img: 'images/SPUTIBTC.svg',
          imgx: 'right',
          imgy: 'top',
          name: 'SPUTIMATIC',
          header: 'Sold put MATIC ',
          priceTicker: 'SPUTIMATIC',
          startDate: "22.02.2023",
          minShares: 100,
          priceText: "USDT",
          content:
            "The strategy aims to make a long-term profit by constantly selling the put option's in-the-money premium and positive delta on MATIC futures.",
          info: {
            img: "images/SPUTIBTC.png",
            header: "Sold put MATIC ",
            content: "",
            params: [[
              "Options: monthly series on MATIC futures",
              "Strikes: in the money with a delta of 0.65-0.75",
              "Leverage: x2",
              "Longing: to the next monthly series one week before the expiration of the current option series",
              "Margin requirements: up to 80% of all strategy funds are used for margin requirements (GM)",
              "Price determination: daily at 9:10 UTC. LAST = Money / Shares. Where Money is the current limit of funds of the strategy account, Shares is the number of subscriptions",
              "Strategy risk: a significant drop in the price of options futures",
            ], [
              "Minimum subscription amount: 100 USDT",
              "Commissions: There is no commission when subscribing to a strategy. When unsubscribing, a commission of 10% of the positive PnL of the subscription is charged.",
              "Subscribe/unsubscribe orders submitted before 9:10 UTC are executed by 10:10 UTC at the LAST price determined at 9:10 UTC."
            ]],
            warning: "Attention! The strategy may have significant risks, up to the complete loss of funds. All possible risks are assumed by the subscriber of the strategy.",

          }
        },*/
      ]
    },
    {
      blockHeader: 'Speculator',
      blockItems: [
        {
          img: 'images/SIVBTC.svg',
          imgx: 'right',
          imgy: 'top',
          name: 'SIVBTC',
          header: 'Selling BTC options volatility',
          priceTicker: 'SIVBTC',
          startDate: "02.08.2022",
          minShares: 100,
          priceText: "USDT",
          content:
            'Sell IV BTC is a strategy to sell IV options on bitcoin futures, profiting from a decrease in the volatility of the IV options, as well as from the temporary decay of the sold options.',
          info: {
            img: "images/SIVBTC.png",
            header: "Selling BTC options volatility",
            content: "",
            params: [[
              "Options: monthly series on BTC futures",
              "Strikes: Central Strike Options",
              "Hedging: by a robot Delta hedger with holding near the neutral delta position. Calculation of the delta position is carried out according to the exchange IV options.",
              "Rolling: options are rolled to the central strike when the delta option leaves the range of 0.35-0.7",
              "Longing: to the next monthly series one week before the expiration of the current option series",
              "Margin requirements: base level GM 20%",
              "SIVBTC price determination: daily at 9:10 UTC. LAST = Money / Shares. Where Money is the current limit of funds of the strategy account, Shares is the number of subscriptions to the SIVBTC instrument",
              "Strategy risk: significant rise in IV options and rising cost of delta hedging."
            ], [
              "Minimum subscription amount: 100 USDT",
              "Commissions: There is no commission when subscribing to a strategy. When unsubscribing, a commission of 10% of the positive PnL of the subscription is charged.",
              "Subscribe/unsubscribe orders submitted before 9:10 UTC are executed by 10:10 UTC at the LAST price determined at 9:10 UTC."
            ]],
            warning: "Attention! The strategy may have significant risks, up to the complete loss of funds. All possible risks are assumed by the subscriber of the strategy.",

          }
        },
      /*  {
          img: 'images/SPUTIBTC.svg',
          imgx: 'right',
          imgy: 'top',
          name: 'SPUTITON',
          header: 'Sold put TON',
          priceTicker: 'SPUTITON',
          startDate: "23.09.2024",
          minShares: 100,
          priceText: "USDT",
          content:
            'The strategy is aimed at long-term profit through the constant sale of in-the-money put option premium and positive delta.',
          info: {
            img: "images/SPUTIBTC.png",
            header: "Sold put TON",
            content: "",
            params: [[
              "Options: monthly series on TON futures (Toncoin)",
              "Strikes: in the money with delta 0.65-0.75",
              "Leverage: x2",
              "Longing: into the next monthly series a week before the expiration of the current options series",
              "Price determination: daily at 9:10 UTC. LAST = Money / Shares. Where Money is the current limit of funds of the strategy account, Shares is the number of subscriptions",
              "Strategy risk: significant drop in the price of TON futures",
            ], [
              "Minimum subscription volume: 100 USDT",
              "Commissions: There is no commission when subscribing to a strategy. When unsubscribing, a commission of 10% of the positive PnL of the subscription is charged.",
              "Subscription/unsubscription requests submitted before 9:10 UTC are executed before 10:10 UTC at the LAST price determined at 9:10 UTC."
            ]],
            warning: "Attention! The strategy may have significant risks, up to and including the complete loss of funds. All possible risks are assumed by the subscriber of the strategy.",

          },
        },*/
        /*  {
            img: 'images/BuyIVBTC.svg',
            imgx: 'right',
            imgy: 'top',
            name: 'BuyIVBTC',
            header: 'Buy BTC options volatility',
            priceTicker: 'BuyIVBTC',
            startDate: "09.08.2022",
            minShares: 100,
            content:
              'Buy IV BTC is a strategy to buy IV options on bitcoin futures that makes a profit when the volatility of IV options increases and the realizable volatility of RV bitcoin futures increases. Long straddle.',
            info: {
              img: "images/BuyIVBTC.png",
              header: "Buy BTC options volatility",
              content: "",
              params: [[
                "Options: monthly series on BTC futures",
                "Strikes: Central Strike Options",
                "Delta hedging: by the ReHedger robot holding near the neutral delta position. ",
                "Calculation of the position delta is carried out according to the exchange IV options.",
                "Rolling: options are rolled to the central strike when the delta option leaves the range of 0.35-0.7",
                "Longing: to the next monthly series one week before the expiration of the current option series",
                "Margin requirements: base level GM 20%",
                "BuyIVBTC price determination: daily at 9:10 UTC. LAST = Money / Shares. Where Money is the current limit of funds of the strategy account, Shares is the number of subscriptions to the BuyIVBTC instrument",
                "Strategy Risk: Decreasing IV options and RV realizable volatility, time decay of option premiums."
              ], [
                "Minimum subscription amount: 100 USDT",
                "Commissions: when subscribing to the strategy, as well as when unsubscribing, no commission is charged. When making trades, an increased commission of the exchange is applied.",
                "Subscribe/unsubscribe orders submitted before 9:10 UTC are executed by 10:10 UTC at the LAST price determined at 9:10 UTC."
              ]],
              warning: "Attention! The strategy may have significant risks, up to the complete loss of funds. All possible risks are assumed by the subscriber of the strategy.",
  
            }
          }*/
      ]
    },
    /*{
      blockHeader: 'Miner',
      blockItems: [*/
    /*{
      img: 'images/HeBTC.svg',
      imgx: 'right',
      imgy: 'top',
      name: 'HedgeBTC',
      header: 'Хеджирование BTC',
      priceTicker: 'HedgeBTC',
      content:
        'Стратегия защиты от сильного падения цены биткоин покупкой put опционов  OTM.',
      info: {
        img: "images/HeBTC.png",
        header: "Хеджирование BTC",
        content: "",
        params: [[
          "Опционы: put месячной серии на фьючерс BTC",
          "Страйки: вне денег с дельтой 0,1-0,2",
          "Лонгирование: в следующую месячную серию за неделю до экспирации текущей серии опционов",
          "Плечо на экспозицию фьючерса: x20",
          "Определение цены: ежедневно в 9:10 UTC. LAST = Money / Shares. Где Money текущий лимит средств аккаунта стратегии, Shares - количество подписок по cтратегии",
          "Риск стратегии: обесценение купленных опционов Put"
        ], [
          "Минимальный объем подписки: 100 USDT",
          "Комиссии: при подписке на стратегию комиссия составляет 0% (ноль) от объема подписки, при отписки комиссия не взимается.",
          "Заявки на подписку/отписку поданные до 9:10 UTC исполняются до 10:10 UTC по цене LAST определенной в 9:10 UTC."
        ]],
        warning: "Внимание! Стратегия может иметь существенные риски, вплоть до полной потери средств. Все возможные риски принимает на себя подписчик стратегии.",
 
      },
    },*/
    /*   {
         img: 'images/HeBTCPlus.svg',
         imgx: 'right',
         imgy: 'top',
         name: 'HedgeBTCPlus',
         header: 'BTC Plus Hedging',
         priceTicker: 'HedgeBTCPlus',
         startDate: "01.09.2022",
         minShares: 100,
         content:
           'Advanced strategy to protect against a strong drop in the price of bitcoin by buying put options and selling Call options OTM. The strategy makes it possible to get insurance for free.',
         info: {
           img: "images/HeBTCPlus.png",
           header: "BTC Plus Hedging",
           content: "",
           params: [[
             "Options: put and call monthly series on BTC futures",
             "Strikes: delta 0.15-0.3",
             "Longing: to the next monthly series one week before the expiration of the current option series",
             "Leverage on futures exposure: 1x",
             "Price determination: daily at 9:10 UTC. LAST = Money / Shares. Where Money is the current limit of funds of the strategy account, Shares is the number of subscriptions according to the strategy",
             "Strategy risk: BTC futures price rises significantly in the absence of full Bitcoin coverage."
           ], [
             "Minimum subscription amount: 100 USDT",
             "Commissions: when subscribing to the strategy, as well as when unsubscribing, no commission is charged. When making trades, an increased commission of the exchange is applied.",
             "Subscribe/unsubscribe orders submitted before 9:10 UTC are executed by 10:10 UTC at the LAST price determined at 9:10 UTC."
           ]],
           warning: "Attention! The strategy may have significant risks, up to the complete loss of funds. All possible risks are assumed by the subscriber of the strategy.",
 
         },
       },*/
    /*  ]
    },*/

    /*
    Стратегии 
  
  Проданный пут BTC SPUTIBTC
  
  Стратегия направлена на долгосрочное получение прибыли за счет постоянной продажи премии опциона пут в деньгах и положительной дельты по биткоин фьючерсу.
  
  Текущая цена 105.55 USDT
  стратегии
  
  кнопки
  Подписаться  Отписаться
  
  форма
  ХХХХХ USDT Отправить заявку
  
  
  Описание
  
  Опционы: месячной серии на фьючерс BTC
  Страйки: в деньгах с дельта 0,65-0,75
  Лонгирование: в следующую месячную серию за неделю до экспирации текущей серии опционов
  Маржинальные требования: под маржинальные требования (GM) используется до 80% всех средств стратегии
  Определение цены SPUTIBTC: ежедневно в 9:10 UTC. LAST = Money / Shares. Где Money текущий лимит средств аккаунта стратегии, Shares - количество подписок на инструмент SPUTIBTC
  
  Заявки на подписку/отписку поданные до 9:10 UTC исполняются до 10:10 UTC по цене LAST определенной в 9:10 UTC.
  Риск стратегии: снижении цены BTC фьючерса при котором премия опциона пут не покроет полученный убыток
  
  Внимание! Стратегия может иметь существенные риски, вплоть до полной потери средств. Все возможные риски принимает на себя подписчик стратегии.
    */
  ]
const indicators = [
  /* {
     img: 'images/icons8-combo-chart.svg',
     imgx: 'right',
     imgy: 'top',
     name: 'HV Crypto',
     header: 'Индикатор HV Crypto для TradingView годовая подписка',
     price: 1.00,
     content:
       '',
     info: {
       img: "images/hv_crypto.png",
       header: "Индикатор исторической волатильности для крипто инструментов",
       content: "Индикатор осуществляет расчет исторической волатильности на любых фьючерсах, свопах и спот криптовалют. Сравнение значение HV Crypto c IV опционов позволяет сделать вывод об переоценки/недооценки опционов.",
       params: [
         "WindowInput - количество баров расчета HV красная линия",
         "WindowInput2 - количество баров расчета HV желтая линия",
         "WindowInput3 - количество баров расчета HV зеленая линия"
       ],
       paramsInfoContent: "Текущие параметры индикатора оптимизированы под часовые бары и отображают:",
       paramsInfo: [
         "красная линия - 1 дневная",
         "желтая линия - 3 дневная",
         "зеленая линия - 5 дневная историческая волатильность."
       ]
     }
   }*/
]
const learningLevels = [
  {
    img: 'images/group277.svg',
    imgx: '',
    imgy: '',
    namebg: 'rgba(40, 163, 232, 0.1)',
    namecolor: '#28a3e8',
    name: 'Базовый',
    header: 'Основы торговли опционами',
    price: 10.00,
    content:
      'Курс предназначен как для начинающих, так и для трейдеров с опытом торговли опционами, желающим расширить и систематизировать свои знания.',
    banners: [{ color: '', text: '', visible: false, angle: '' }],
    program: [
      {
        title: 'Новый Базовый курс обучения Сергея Елисеева',
        text: 'Полностью переработан в 2021 году'
      },
      {
        title: 'Обучение в удобное время',
        text: 'Срок доступа к материалам курса 1 год'
      },
      {
        title: '5 видео уроков',
        text: 'По темам 1-5 доступны в видеозаписях'
      },
      {
        title: 'Проверка знаний',
        text: 'Контрольные тесты к урокам и домашнии задания'
      },
    ],
    goals: [
      {
        img: 'images/icons8-candlestick-chart.svg',
        title: 'Основные термины',
        text: 'Понятие основных терминов опционной торговли'
      },
      {
        img: 'images/icons8-combo-chart.svg',
        title: 'Понимание основ',
        text: 'Основы ценообразования опционов'
      },
      {
        img: 'images/icons8-options.svg',
        title: 'Греки опционов',
        text: 'Что такое греки опционов и как их использовать в анализе'
      },
      {
        img: 'images/icons8-chart.svg',
        title: 'Оценка риска',
        text: 'Риск основной инструмент трейдера опционов'
      },
      {
        img: 'images/icons8-monitor.svg',
        title: 'Навыки работы с терминалом',
        text: 'Научитесь создавать и анализировать опционные стратегии'
      },
    ],
    topics: [
      {
        title: 'Тема 1. Торговля опционами. Начало',
        items: [
          'Основные термины опционной торговли',
          'Типы и виды опционов',
          'Параметры опционов',
          'Математика опционов',
          'Участники торгов опционов',
          'Биржи опционов'
        ]
      },
      {
        title: 'Тема 2. Ключевые моменты ценообразования опционов',
        items: [
          'Внутренняя стоимость и временная премия опциона',
          'График опционных контрукций',
          'Call Put паритет',
          'Синтетический фьючерс',
          'Арбитраж опционов'
        ]
      },
      {
        title: 'Тема 3. Греки опционов и применение их в торговле',
        items: [
          'Delta основной грек и риск параметр',
          'Gamma как скорость изменения дельты',
          'Вега и зависимость премии опциона от IV',
          'Theta и временной распад премии опциона',
          'Нелинейные свойства греков',
          'Рыночные реалии и расчетные греки',
          'Неправильная дельта'
        ]
      },
      {
        title: 'Тема 4. Классы опционных стратегий. Риски и ошибки в торговле опционами',
        items: [
          'Трендовые и контртрендовые стратегии',
          'Календарные и стратегии торговли волатильностью',
          'Арбитражные и стратегии хеджирования',
          'Рыночный риск и риск изменения IV',
          'Риски исполнения, ГО и технические',
          'Основные ошибки в торговле опционами'
        ]
      },
      {
        title: 'Тема 5. Рыночно направленные опционные стратегии',
        items: [
          'Голые покупки и продажи опционов',
          'Покрытые продажи опционов',
          'Вертикальные спреды',
          'Принципы построения',
          'Маржинальные требования и PnL',
          'Ratio спреды и Back ratio спреды'
        ]
      },
    ]
  },
  {
    img: 'images/frame117.svg',
    imgx: '',
    imgy: '',
    namebg: 'rgba(40, 163, 232, 0.1)',
    namecolor: '#28a3e8',
    name: 'Эксперт',
    header: 'Эффективная торговля IV опционов',
    price: 10.00,
    content:
      'Уровень Эксперт дает знания и навыки оценки опционов и возможности получения прибыли от рыночно нейтральной торговли опционами.',
    banners: [{ color: '', text: '', visible: false, angle: '' }],
    program: [
      {
        title: 'Новый курс обучения Эксперт Сергея Елисеева',
        text: 'Полностью переработан в 2021 году'
      },
      {
        title: 'Обучение в удобное время',
        text: 'Срок доступа к материалам курса 1 год'
      },
      {
        title: '5 видео уроков',
        text: 'По темам 1-5 доступны в видеозаписях '
      },
      {
        title: 'Проверка знаний',
        text: 'Контрольные тесты к урокам и домашнии задания'
      },
    ],
    goals: [
      {
        img: 'images/icons8-candlestick-chart.svg',
        title: 'Волатильность',
        text: 'Понятие волатильности и методик расчета'
      },
      {
        img: 'images/icons8-combo-chart.svg',
        title: 'Понимание основ',
        text: 'Понимание поведения кривых волатильности опционных серий'
      },
      {
        img: 'images/icons8-options.svg',
        title: 'Рыночно нейтральные стратегии',
        text: 'Навыки создания нейтральных опционных стратегий'
      },
      {
        img: 'images/icons8-chart.svg',
        title: 'Оценка опционов',
        text: 'Научись оценке опционов и правильному выбору опционной стратегии'
      },
      {
        img: 'images/icons8-monitor.svg',
        title: 'Навыки работы с терминалом',
        text: 'Научитесь создавать, анализировать и торговать опционные стратегии'
      },
    ],
    topics: [
      {
        title: 'Тема 1. Волатильность',
        items: [
          'Что такое волатильность',
          'Историческая волатильность HV',
          'Реализуемая волатильность RV',
          'Ожидаемая волатильность IV',
          'Задачи оценки опционов',
        ]
      },
      {
        title: 'Тема 2. Кривая волатильности серии опционов',
        items: [
          'Формы кривых IV',
          'Сплайн кривой',
          'Изменения кривой при изменениях цены БА',
          'Изменения кривой с приближением даты экспирации',
          'Ожидания рынка в кривой IV опционов'
        ]
      },
      {
        title: 'Тема 3. Продажа волатильности. Продажа опционов с дельта хеджированием',
        items: [
          'Выбор опционов',
          'Доходность и риски',
          'Использование своей кривой IV опционов',
          'Робот Дельта хеджер ( Range Hedger )',
          'Диапазон дельты хеджирования',
        ]
      },
      {
        title: 'Тема 4. Покупка волатильности. Покупка опционов с дельта рехеджированием',
        items: [
          'Поиск опционов для покупки',
          'Потенциал прибыли и риск',
          'Робот рехеджер, параметры ( ReHedger )',
          'Низкая ликвидность, гэпи и комиссии',
        ]
      },
      {
        title: 'Тема 5. Стратегии торговли волатильностью',
        items: [
          'Торговля опционами на отчетности акций',
          'Ловушки покупки волатильности',
          'Торговля спредами IV ( арбитраж кривой воалитльности )',
          'Продажи волатильности в стратегиях инвестирования',
        ]
      },
    ]
  },
  /*   {
       img: 'images/frame120.svg',
       imgx: '',
       imgy: '',
       namebg: 'rgba(40, 163, 232, 0.1)',
       namecolor: '#28a3e8',
       name: 'Системный',
       header: 'Системная торговля опционами',
       content:
         'Системный уровень предоставляет трейдеру знания по торговле опционами в соответствии с заранее разработанным торговым планом.',
       banners: [{ color: '', text: '', visible: false, angle: '' }],
       goals: [{ img: '', title: '', text: '' }]
     },
     {
       img: 'images/group245.svg',
       imgx: '',
       imgy: '',
       namebg: 'rgba(40, 163, 232, 0.1)',
       namecolor: '#28a3e8',
       name: 'Мастер',
       header: 'Алго торговля волатильностью',
       content:
         'Уровень Мастер дает уникальную информацию слушателю по торговле роботами эмулирующими покупку или продажу опционов реализующие трендовые и контртрендовые алго стратегии.',
       banners: [{ color: '', text: '', visible: false, angle: '' }],
       goals: [{ img: '', title: '', text: '' }]
     },
     {
       img: 'images/frame117.svg',
       imgx: '',
       imgy: '',
       name: 'Глобал',
       namebg: '#fff0f5',
       namecolor: '#e82862',
       header: 'Опционы мировых бирж',
       content:
         'Выход на торговлю опционами на мировых биржах. <br>Самые популярные опционы ведущих бирж.',
       banners: [{ color: '', text: '', visible: false, angle: '' }],
       goals: [{ img: '', title: '', text: '' }]
     },*/
];
/*type MailSend struct {
  To      string
  Subject string
  Body    string
}*/
